



// import { Checkbox } from "antd";
// import { Fragment, useEffect, useMemo, useRef, useState } from "react";
// import {
//   useAsyncDebounce,
//   useBlockLayout,
//   useColumnOrder,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import { useSticky } from "react-table-sticky";
// // import { common_axios } from "../../../..";
// import { common_axios } from "../../../../../App";
// import { toast, ToastContainer } from "react-toastify";
// import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
// import ColumnFilter from "../../UserManagement/UserNewModule.jsx/ColumnFilter";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import TableViewIcon from "@mui/icons-material/TableView";
// import {
//   Autocomplete,
//   Backdrop,
//   FormControl,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Popover,
//   Select,
//   TextField,
//   ThemeProvider,
//   Typography,
//   Tooltip,
// } from "@mui/material";
// import CancelIcon from "@mui/icons-material/Cancel";
// import Loader from "../../../../../components/Loader";
// import { SettingsInputComponent } from "@mui/icons-material";
// import SearchIcon from "@mui/icons-material/Search";
// import { createTheme } from "@mui/material/styles";
// import BlockIcon from "@mui/icons-material/Block";
// import Zoom from "react-medium-image-zoom";
// import { Link } from "react-router-dom";
// import { Option } from "antd/lib/mentions";
// import { useFormik } from "formik";
// import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
// import Swal from "sweetalert2";
// import SettingsIcon from "@mui/icons-material/Settings";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import RefreshIcon from "@mui/icons-material/Refresh";

// export default function UserTableApproved() {
//   const [open, setOpen] = useState(false);
//   const [count, setcount] = useState(0);
//   const [roleTypes, setRoleTypes] = useState("");
//   const [openTextfield, setOpenTextField] = useState({});

//   const [searchStatus, setSearchStatus] = useState(true);

//   const [badgestatus, setbadgestatus] = useState(false);
//   const [searchIcon, setSearchIcon] = useState(false);
//   const [data, setData] = useState([]);
//   const [data1, setData1] = useState([]);

//   const [searchBar, setSearchBar] = useState(false);
//   const customId1 = "custom-id-yess";
//   const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
//   const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
//     useState(undefined);
//   const [selectUserDetailsUpdate, setSelectUserDetailsUpdate] =
//     useState(undefined);
//   const [selectVerifyDocuments, setSelectVerifyDocuments] = useState(undefined);
//   const [selectUnblockDetails, setSelectUnblockDetails] = useState(undefined);
//   const [selectUserDetailsBlock, setSelectUserDetailsBlock] =
//     useState(undefined);
//   const [Status, setStatus] = useState({
//     tab: 5,
//     role: null,
//     userName: "",
//     msisdn: "",
//     status: null,
//     icon: false,
//     pageNo: 0,
//     pageSize: 10,
//     searchType: null,
//   });
//   const [refreshButtonState, setRefreshButtonState] = useState(false);
//   const [apiNotHit, setApiNotHit] = useState(false);

//   const [rejectedReasonValues, setRejectedReasonValues] = useState(undefined);
//   const [anchorEl, setAnchorEl] = useState(null);

//   const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));

//   const handlePopoverOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handlePopoverClose = () => {
//     setAnchorEl(null);
//   };
//   const open1 = Boolean(anchorEl);

//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: {
//             color: "red",
//           },
//         },
//       },
//     },
//   });

//   const showSearch = () => {
//     if (Status.tab == 1 || Status.tab == 3) {
//       setSearchStatus(true);
//     } else {
//       setSearchStatus(false);
//     }
//   };

//   // const emptyRole = () => {
//   //   if (Status == 1 || Status == 3 || Status == 4) {
//   //     setTimeout(() => {
//   //       search.role = null && (search.msisdn = "") && (search.userName = "");
//   //     }, 1000);
//   //   }
//   // };
//   useEffect(async () => {
//     await showSearch();
//     // await emptyRole();
//   }, [Status.tab]);

//   const fetchUser = async () => {
//     setOpen(true);
//     setData([]);
//     try {
//       const res = await common_axios.post("/admin/v1/admin/fetch/user-status", {
//         userStatus: Status?.tab,
//         pageNo: Status?.pageNo,
//         pageSize: Status?.pageSize,
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         if (res.data?.userModel) {
//           setData(res.data?.userModel?.content);
//           setData1(res.data?.userModel);
//           setRefreshButtonState(false);
//           setApiNotHit(false)
//         }
//       } else if (res.data.statusDescription.statusCode == 220) {
//         setData([]);
//         setOpen(false);
//       } else {
//         setOpen(false);
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }

//     // const res = await common_axios(
//     //   `admin/v1/reseller/fetch/user-status/?userStatus=approved`
//     // );
//   };
//   useEffect(async () => {
//     fetchUser();
//     getCountApi();
//   }, [Status.tab, Status.pageNo, Status.pageSize]);


//   const RefreshBtn = async () => {
//     setOpen(true);
//     setData([]);
//     try {
//       const res = await common_axios.post("/admin/v1/admin/fetch/user-status", {
//         userStatus: Status?.tab,
//         pageNo: Status?.pageNo,
//         pageSize: Status?.pageSize,
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         if (res.data?.userModel) {
//           setData(res.data?.userModel?.content);
//           setData1(res.data?.userModel);
//           // setRefreshButtonState(false);
//           // setApiNotHit(false)
//         }
//       } else if (res.data.statusDescription.statusCode == 220) {
//         setData([]);
//         setOpen(false);
//       } else {
//         setOpen(false);
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }

//     // const res = await common_axios(
//     //   `admin/v1/reseller/fetch/user-status/?userStatus=approved`
//     // );
//   };
//   const findUser = async () => {
//     try {
//       setOpen(true);
//       const res = await common_axios.post(`admin/v1/user/find`, {
//         role: Status.role,
//         userName: Status.userName != "" ? Status.userName : null,
//         msisdn: Status.msisdn != "" ? Status.msisdn : null,
//         activeStatus: Status.status == null ? Status.status : [Status.status],
//         pageNo: Status?.pageNo,
//         pageSize: Status?.pageSize,
//         userStatus: Status?.tab,
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         setData(res.data?.userModel?.content);
//         setData1(res.data?.userModel);
//         // setStatus({
//         //   ...Status,
//         //   userName: "",
//         // });
//         setOpen(false);
//         setApiNotHit(true);

//         setRefreshButtonState(false);
//       } else if (res.data?.statusDescription?.statusCode == 201) {
//         setData([]);
//         setOpen(false);
//         setApiNotHit(true);
//         // setStatus({
//         //   ...Status,
//         //   resellerName: "",
//         // });
//         setRefreshButtonState(true);
//         // await toast.error(res.data?.statusDescription?.statusMessage, {
//         //   theme: "colored",
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "No Record Found",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         // await toast.error("No data Found", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "No data Found",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   const getCountApi = async () => {
//     const res = await common_axios(
//       `${process.env.REACT_APP_COMMON_API}/admin/v1/${
//         roleType.name == "ROLE_RESELLER" ? "reseller" : "admin"
//       }/user/status/count/`
//     );

//     if (res.data.statusDescription.statusCode == 200) {
//       let obj = {
//         allCount: 0,
//       };

//       for (let index = 0; index < res?.data?.userStatusList?.length; index++) {
//         const element = res?.data?.userStatusList?.[index];

//         if (element.status == 1) {
//           obj["apporved"] = element.count;
//           obj["allCount"] += element.count;
//         }
//         if (element.status == 3) {
//           obj["blocked"] = element.count;
//           obj["allCount"] += element.count;
//         }
//       }
//       setcount(obj);
//     }
//   };

//   const defaultColumn = useMemo(() => {
//     return {
//       Filter: ColumnFilter,
//     };
//   }, []);
//   const modelButtonReject = useRef(null);
//   const modelButtonRejectClose = useRef();
//   const modelButtonApprove = useRef(null);
//   const modelVerifyDocuments = useRef(null);
//   const modelEditUser = useRef(null);
//   const modelblockedUser = useRef(null);
//   const verifyDetails = useRef(null);
//   const unblockUser = useRef(null);
//   const modelCloseUnlock = useRef(null);

//   const modelUpdateUser = useRef(null);
//   const updateUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectUserDetailsUpdate(cell.row.original);
//     // await setSelectedUserDetailApprove(cell.row.original);
//     await modelCloseUnlock.current?.click();
//   };

//   const approveUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectedUserDetailApprove(cell.row.original);
//     await modelButtonApprove.current?.click();
//     let objectt = {};
//     await cell.row.original.documentList.forEach((element) => {
//       // console.log(element);
//       objectt[element.documentType] = false;
//     });

//     setOpenTextField(objectt);
//     await setSelectVerifyDocuments(cell.row.original);
//     // await modelVerifyDocuments.current.click();
//   };
//   const editApprovedModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectUserDetailsBlock(cell.row.original);
//     // await setSelectedUserDetailApprove(cell.row.original);
//     await modelEditUser.current?.click();
//   };
//   const blockedUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await modelblockedUser.current.click();
//   };

//   const rejectUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setRejectedReasonValues(cell.row.original);
//     await setSelectedUserDetail(cell.row.original);
//     await modelButtonReject.current.click();
//   };
//   const unblockUserModal = async (cell) => {
//     // console.log(cell.row.original);
//     await setSelectUnblockDetails(cell?.row?.original);
//     await unblockUser?.current?.click();
//   };
//   const verifyDocumentsModal = async (cell) => {
//     let objectt = {};
//     await cell.row.original.documentList.forEach((element) => {
//       // console.log(element);
//       objectt[element.documentType] = false;
//     });

//     setOpenTextField(objectt);
//     await setSelectVerifyDocuments(cell.row.original);
//     await modelVerifyDocuments.current.click();
//   };

//   const rejectUserApi = async (e) => {
//     e.preventDefault();
//     try {
//       modelButtonRejectClose.current?.click();
//       setOpen(true);
//       const res = await common_axios.post(`/admin/v1/user/reject/`, {
//         cpId: selectedUserDetail.uid,
//         rejectReason:
//           selectedUserDetail.rejectedReason == "Other"
//             ? selectedUserDetail.rejectedReasonText
//             : selectedUserDetail.rejectedReason,
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         await modelButtonRejectClose.current?.click();
//         setOpen(false);
//         setSelectedUserDetail();
//         fetchUser();
//         // await toast.success("User has been rejected", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "User has been rejected",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         await setOpen(false);
//         await fetchUser();
//         await setSelectedUserDetail();
//         // await toast.error(res.data.statusDescription.description, {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.description,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       modelButtonRejectClose.current?.click();
//       await setSelectedUserDetail();
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   const unblockUserAPi = async (e, cell) => {
//     e.preventDefault();
//     try {
//       setOpen(true);
//       const res = await common_axios.post(
//         `/admin/v1/unblock/user/?cpId=${selectUnblockDetails?.uid}`,
//         {
//           cpId: selectUnblockDetails?.uid,
//           unBlockReason: selectUnblockDetails.rejectedReason,
//           // unBlockReason: "is a valid user",
//         }
//       );

//       if (res.data.statusDescription.statusCode == 200) {
//         modelCloseUnlock?.current?.click();
//         setSelectUnblockDetails();
//         fetchUser();
//         setOpen(false);
//         // await setStatus("approved");
//         // await toast.success("User unblocked", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "User unblocked",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         // await toast.error(res.data.statusDescription.description, {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.description,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       modelCloseUnlock?.current?.click();
//       setSelectUnblockDetails();
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   const approveUserApi = async (cell) => {
//     try {
//       setOpen(true);
//       const res = await common_axios(
//         `/admin/v1/user/approve/?cpId=${selectedUserDetailApprove.uid}`
//       );

//       if (res.data.statusDescription.statusCode == 200) {
//         fetchUser();
//         setOpen(false);
//         // await setStatus("approved");
//         // await toast.success("User has been approved", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "User has been approved",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusdescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   const blockUserAPI = async (cell) => {
//     try {
//       setOpen(true);
//       const res = await common_axios(
//         `/admin/v1/block/user/?cpId=${selectUserDetailsBlock?.uid}`
//       );

//       if (res.data.statusDescription.statusCode == 200) {
//         fetchUser();
//         setOpen(false);
//         // await setStatus("approved");
//         // await toast.success("User has been Blocked", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "User has been Blocked",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusdescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   // const rejectUser = async (cpId) => {
//   //   const res = await common_axios.post(`/admin/v1/user/reject/`, {
//   //     cpId,
//   //     rejectReason: "not valid user",
//   //   });
//   //   await setStatus("rejected");

//   //   console.log(res.data);
//   // };

//   const approveUser = async (cpId) => {
//     const res = await common_axios(`/admin/v1/user/approve/?cpId=${cpId}`);

//     await setStatus("approved");

//     // console.log(res.data);
//   };

//   const columns = useMemo(
//     () => [
//       // {
//       //   Header: "S.No",
//       //   Footer: "S.No",
//       //   accessor: "serialnumber",
//       //   Cell: (row, index) => {
//       //     console.log(row, "helloo");
//       //     return <>{row.row.index}</>;
//       //   },
//       // },
//       {
//         Header: "Id",
//         accessor: "id",
//         Cell: (cell) => (
//           //  <>{cell.row.index +1}</>
//           <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
//         ),
//       },
//       {
//         Header: "User Name",
//         Footer: "User Name",
//         accessor: "username", // accessor is the "key" in the data
//       },
//       // {
//       //   Header: "Role",
//       //   Footer: "Role",
//       //   accessor: "userRoleId",
//       // },
//       {
//         Header: "Email-Id",
//         Footer: "Email-Id",
//         accessor: "email",
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             <div>
//               {cell.row.original.email ? (
//                 <div>{cell.row.original.email}</div>
//               ) : (
//                 <div>NA</div>
//               )}
//             </div>
//           );
//         },
//       },
//       {
//         Header: "Role",
//         Footer: "Role",
//         accessor: "roleName",
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             // <div>
//             //   {cell.row.original.roleName == "user" ? (
//             //     <div>User</div>
//             //   ) : (
//             //     <div>Reseller</div>
//             //   )}
//             // </div>
//             <>
//               {cell.row.original.roleName == "user" ? (
//                 <>
//                   <div>User</div>
//                 </>
//               ) : cell.row.original.roleName == "reseller" ? (
//                 <>
//                   <div>Reseller</div>
//                 </>
//               ) : cell.row.original.roleName == "admin" ? (
//                 <>
//                   <div>Admin</div>
//                 </>
//               ) : (
//                 <>N/A</>
//               )}
//             </>
//           );
//         },
//       },
//       {
//         Header: " Account Status",
//         Footer: " Account Status",
//         accessor: "status",
//         Cell: (cell) => {
//           // console.log(
//           //   cell,
//           //   cell.row.original,
//           //   cell.row.original.status,
//           //   cell.cell.row.original.enabled
//           // );
//           // const function2 = () => {
//           //   if (cell.row.original.enabled == "false") {
//           //     <div className="badge rounded-pill bg-danger">Blocked</div>;
//           //   }
//           // };
//           // console.log("going", cell.row.original.enabled == false);
//           return (
//             <>
//               {cell.row.original.approved == 3 ? (
//                 <>
//                   {" "}
//                   <div className="badge badge_8 failClr fs_table_up">
//                     Blocked
//                   </div>
//                 </>
//               ) : cell.row.original.approved == 0 ? (
//                 <>
//                   {" "}
//                   <div className="badge badge_8 pending_Up fs_table_up">
//                     Pending{" "}
//                   </div>
//                 </>
//               ) : cell.row.original.approved == 1 ? (
//                 <>
//                   <div className="badge badge_8 approved_Up fs_table_up">
//                     Approved
//                   </div>
//                 </>
//               ) : cell.row.original.approved == 2 ? (
//                 <>
//                   {" "}
//                   <div className="badge badge_8 failClr fs_table_up">
//                     Rejected
//                   </div>
//                 </>
//               ) : (
//                 <></>
//               )}
//             </>
//           );
//         },
//       },
//       // {
//       //   Header: "Mobile Verfication",
//       //   Footer: " Mobile  Verfication",
//       //   accessor: "otpVerification",
//       //   Cell: (cell) => {
//       //     console.log(cell.row.original, cell.row.original.status);
//       //     return (
//       //       // <div>
//       //       //   {cell.row.original.roleName == "user" ? (
//       //       //     <div>User</div>
//       //       //   ) : (
//       //       //     <div>Reseller</div>
//       //       //   )}
//       //       // </div>
//       //       <>
//       //         {cell.row.original.otpVerification == true &&
//       //         cell.row.original.approved == 0 ? (
//       //           <>
//       //             <div className="badge badge_8 bg-success">Verified</div>
//       //           </>
//       //         ) : cell.row.original.otpVerification == false &&
//       //           "null" &&
//       //           cell.row.original.approved == 0 ? (
//       //           <>
//       //             <div className="badge badge_8 bg-warning">Not Verified</div>
//       //           </>
//       //         ) : cell.row.original.otpVerification == true &&
//       //           "null" &&
//       //           cell.row.original.approved == 1 ? (
//       //           <>
//       //             <div className="badge badge_8 bg-success">Verified</div>
//       //           </>
//       //         ) : cell.row.original.otpVerification == false ||
//       //           ("null" && cell.row.original.approved == 2) ? (
//       //           <>
//       //             <div className="badge badge_8 bg-warning">Not Verified</div>
//       //           </>
//       //         ) : (
//       //           cell.row.original.otpVerification == false ||
//       //           ("null" && cell.row.original.approved == 3 && (
//       //             <>
//       //               <div className="badge badge_8 bg-warning">Not Verified</div>
//       //             </>
//       //           ))
//       //         )}
//       //       </>
//       //     );
//       //   },
//       // },
//       {
//         Header: "Mobile Number",

//         accessor: "mobile",
//       },
//       // {
//       //   Header: "Details",
//       //   Footer: "Details",
//       //   accessor: "details",
//       //   Cell: (cell) => {
//       //     return (
//       //       <>
//       //         <Link to={`/dashboard/UserDetail/${cell.row.original.uid}`}>
//       //           <button className="btn btn-primary mb-0" type="button">
//       //             Configuration
//       //           </button>
//       //         </Link>
//       //       </>
//       //     );
//       //   },

//       //   disableFilters: true,
//       // },
//       {
//         Header: "Action",
//         Footer: "Action",
//         accessor: "action",
//         Cell: (cell) => {
//           return (
//             <div className="d-flex justify-content-center align-items-center">
//               <div className="dropdown">
//                 <button
//                   className="btn color_1 dropdown-toggle px-2"
//                   type="button"
//                   id="dropdownMenuButton1"
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   <i className="material-icons opacity-10 size">person</i>
//                 </button>
//                 {cell.row.original.enabled == false ? (
//                   <>
//                     <ul
//                       className="dropdown-menu"
//                       aria-labelledby="dropdownMenuButton1"
//                     >
//                       <li>
//                         <a
//                           className="dropdown-item"
//                           onClick={() => {
//                             unblockUserModal(cell);
//                           }}
//                         >
//                           <i
//                             className="fa fa-unlock color_Green_UP me-2"
//                             aria-hidden="true"
//                           ></i>
//                           Unblock User
//                         </a>
//                       </li>
//                     </ul>
//                   </>
//                 ) : cell.row.original.approved == 0 ? (
//                   <>
//                     <ul
//                       className="dropdown-menu"
//                       aria-labelledby="dropdownMenuButton1"
//                     >
//                       <li
//                         onClick={() => {
//                           // console.log(cell, "hello");
//                         }}
//                       >
//                         <a
//                           className="dropdown-item "
//                           onClick={() => {
//                             rejectUserModal(cell);
//                           }}
//                         >
//                           <i className="fa fa-ban me-2" aria-hidden="true"></i>
//                           Reject User
//                         </a>
//                       </li>
//                       <li>
//                         <a
//                           className="dropdown-item"
//                           onClick={() => {
//                             approveUserModal(cell);
//                           }}
//                         >
//                           <i
//                             className="fa fa-thumbs-up me-2"
//                             aria-hidden="true"
//                           ></i>
//                           Approve User
//                         </a>
//                       </li>
//                       {/* <li>
//                       <Link to={`/dashboard/EditUser/${cell.row.original.uid}`}>
//                         <EditIcon />
//                         Edit User
//                       </Link>
//                     </li> */}
//                     </ul>
//                   </>
//                 ) : cell.row.original.approved == 1 ? (
//                   <>
//                     <ul
//                       className="dropdown-menu"
//                       aria-labelledby="dropdownMenuButton1"
//                     >
//                       {/* <li className="dropdown-item">
//                       <Link
//                         to={`/dashboard/UserDetail/${cell.row.original.uid}`}
//                       >
//                         View Details
//                       </Link>
//                     </li> */}

//                       <li>
//                         <a
//                           className="dropdown-item"
//                           onClick={() => {
//                             editApprovedModal(cell);
//                           }}
//                         >
//                           {/* <i className="fa fa-pencil me-2 color_Green_UP" aria-hidden="true"></i> */}
//                           <BlockIcon className="color_red_UP me-2 my-auto" />
//                           Block User
//                         </a>
//                       </li>
//                     </ul>
//                   </>
//                 ) : (
//                   cell.row.original.approved == 2 && (
//                     <>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="dropdownMenuButton1"
//                       >
//                         {/* <li className="dropdown-item">
//                         <Link
//                           to={`/dashboard/UserDetail/${cell.row.original.uid}`}
//                         >
//                           <i className="fa fa-info-circle" aria-hidden="true"></i>
//                           View Details
//                         </Link>
//                       </li> */}
//                         <li>
//                           <a
//                             className="dropdown-item"
//                             onClick={() => {
//                               updateUserModal(cell);
//                             }}
//                           >
//                             <ThumbUpAltIcon />
//                             Update User
//                           </a>
//                         </li>
//                       </ul>
//                     </>
//                   )
//                 )}
//               </div>
//               <ul>
//                 <li>
//                   <a
//                     className="dropdown-item px-2"
//                     // onClick={() => {
//                     //   approveUserModal(cell);
//                     // }}
//                   >
//                     <Link to={`/dashboard/UserDetail/${cell.row.original.uid}`}>
//                       <SettingsIcon />
//                     </Link>
//                     {/* View Details */}
//                   </a>
//                 </li>
//               </ul>
//             </div>
//           );
//         },

//         disableFilters: true,
//       },
//     ],
//     [Status]
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     // footerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     selectedFlatRows,
//     setColumnOrder,
//     allColumns,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//       defaultColumn,
//       // initialState: { pageIndex: 1 }
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//     // useColumnOrder,
//     // useBlockLayout,
//     // useSticky,
//     // (hooks) => {
//     //   hooks.visibleColumns.push((columns) => {
//     //     return [
//     //       {
//     //         id: "selection",
//     //         Header: ({ getToggleAllRowsSelectedProps }) => (
//     //           <CheckBox {...getToggleAllRowsSelectedProps()} />
//     //         ),
//     //         Cell: ({ row }) => (
//     //           <CheckBox {...row.getToggleRowSelectedProps()} />
//     //         ),
//     //       },
//     //       ...columns,
//     //     ];
//     //   });
//     // }
//   );

//   const { globalFilter, pageIndex, pageSize } = state;

//   const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

//   const onChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 1000);

//   const deletUser = () => {
//     // console.log({ selectedFlatRows });
//   };

//   const changeOrder = () => {
//     setColumnOrder(["id", "username", "action", "role", "email"]);
//   };

//   const approveDocument = async (docu) => {
//     try {
//       setOpen(true);
//       modelClose?.current?.click();
//       const res = await common_axios.post(`admin/v1/document/verify`, {
//         docId: docu.id,
//         cpId: selectVerifyDocuments.uid,
//         action: "approve",
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         setbadgestatus(true);

//         fetchUser();
//         setOpen(false);
//         modelClose?.current?.click();
//         // await setStatus("pending");
//         // await toast.success("Document Approved", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "Document Approved",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusdescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   const rejectDocument = async (e, docu) => {
//     e.preventDefault();

//     try {
//       setOpen(true);
//       const res = await common_axios.post(`admin/v1/document/verify`, {
//         docId: selectVerifyDocuments.documentId.id,
//         cpId: selectVerifyDocuments.uid,
//         action: "reject",
//         rejectReason: selectVerifyDocuments.rejectReason,
//       });

//       if (res.data.statusDescription.statusCode == 200) {
//         fetchUser();
//         setOpen(false);
//         modelClose?.current?.click();
//         // await setStatus("pending");
//         // await toast.success("Document Rejected", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         // });

//         Swal.fire({
//           icon: "success",
//           //  title: "Oops...",
//           text: "Document Rejected",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusdescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   const modelOpen = useRef();
//   const modelClose1 = useRef();
//   const modelClose = useRef();

//   const textfiledRef = useRef(null);

//   const textfieldClick = async () => {
//     await textfiledRef.current.click();
//   };

//   const openInNewTab = (url) => {
//     const newWindow = window.open(url, "_blank", "noopener,noreferrer");
//     if (newWindow) newWindow.opener = null;
//   };

//   // console.log({ selectVerifyDocuments });
//   // console.log({ selectedUserDetail });

//   useEffect(() => {
//     if (Status?.userName === "" && apiNotHit === true) {
//       alert("enter")
//       fetchUser();
//     }
//   }, [Status?.userName]);
//   console.log("xyx--",refreshButtonState,apiNotHit,Status?.userName)
//   return (
//     <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//       {selectedUserDetail != undefined && (
//         <div>
//           <button
//             ref={modelButtonReject}
//             type="button"
//             className="btn btn-primary d-none"
//             data-bs-toggle="modal"
//             data-bs-target="#staticBackdrop1"
//           >
//             Launch static backdrop modal
//           </button>
//           <form onSubmit={rejectUserApi}>
//             <div
//               className="modal fade"
//               id="staticBackdrop1"
//               data-bs-backdrop="static"
//               data-bs-keyboard="false"
//               tabIndex="-1"
//               aria-labelledby="staticBackdrop1Label"
//               aria-hidden="true"
//             >
//               <div className="modal-dialog">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <h5 className="modal-title" id="staticBackdrop1Label">
//                       User Rejection
//                     </h5>
//                     <button
//                       type="button"
//                       className="btn-close"
//                       data-bs-dismiss="modal"
//                       aria-label="Close"
//                     ></button>
//                   </div>

//                   <div className="modal-body">
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Username:
//                         </label>
//                         <input
//                           disabled
//                           type="text"
//                           value={selectedUserDetail?.username}
//                           className="form-control"
//                           id="exampleInputEmail1"
//                           aria-describedby="emailHelp"
//                         />
//                       </div>
//                       <div className="col-md-6 mt_2">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Email-Id :
//                         </label>
//                         <input
//                           disabled
//                           type="text"
//                           value={selectedUserDetail?.email}
//                           className="form-control"
//                           id="exampleInputEmail1"
//                           aria-describedby="emailHelp"
//                         />
//                       </div>
//                     </div>
//                     <div className="row mt-2">
//                       <div className="col-md-6">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Phone-Number:
//                         </label>
//                         <input
//                           disabled
//                           type="text"
//                           value={selectedUserDetail?.mobile}
//                           className="form-control"
//                           id="exampleInputEmail1"
//                           aria-describedby="emailHelp"
//                         />
//                       </div>
//                       <div className="col-md-6">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Rolename:
//                         </label>
//                         <input
//                           disabled
//                           required
//                           className="form-control"
//                           placeholder="Sender Id Here"
//                           type="text"
//                           minLength="3"
//                           value={selectedUserDetail?.roleName}
//                         />
//                       </div>
//                     </div>
//                     <div className="row">
//                       <div className="col-md-6">
//                         <label className="fw-bold mt-3 w-100">
//                           Rejected Reason :
//                           <select
//                             required
//                             className="form-select mt-2"
//                             name="reason"
//                             id="reason"
//                             onChange={(e) => {
//                               if (e.target.value == "Other") {
//                                 selectedUserDetail.rejectedReasonText = "";
//                               }
//                               setSelectedUserDetail({
//                                 ...selectedUserDetail,
//                                 rejectedReason: e.target.value,
//                               });
//                             }}
//                           >
//                             <option value="Incorrect User Information">
//                               Incorrect User Information
//                             </option>
//                             <option value="Incorrect Documents">
//                               Incorrect Documents
//                             </option>
//                             <option value="Details-Documents Mismatch">
//                               Details-Documents Mismatch
//                             </option>
//                             <option value="Other">Other</option>
//                           </select>
//                           {selectedUserDetail.rejectedReason == "Other" && (
//                             <input
//                               required
//                               className="form-control mt-2"
//                               placeholder="Rejected Reason Here"
//                               type="text"
//                               value={selectedUserDetail.rejectedReasonText}
//                               onChange={(e) => {
//                                 setSelectedUserDetail({
//                                   ...selectedUserDetail,
//                                   rejectedReasonText: e.target.value,
//                                 });
//                               }}
//                             />
//                           )}
//                         </label>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="modal-footer">
//                     <button
//                       ref={modelButtonRejectClose}
//                       type="button"
//                       className="btn btn-secondary"
//                       data-bs-dismiss="modal"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="btn btn-primary"
//                       // data-bs-dismiss="modal"
//                     >
//                       Reject User
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//       )}

//       {selectUnblockDetails != undefined && (
//         <>
//           <div>
//             <button
//               ref={unblockUser}
//               type="button"
//               className="btn btn-primary d-none"
//               data-bs-toggle="modal"
//               data-bs-target="#staticBackdrop9"
//             >
//               Launch static backdrop modal
//             </button>
//             <form onSubmit={unblockUserAPi}>
//               <div
//                 className="modal fade"
//                 id="staticBackdrop9"
//                 data-bs-backdrop="static"
//                 data-bs-keyboard="false"
//                 tabindex="-1"
//                 aria-labelledby="staticBackdropLabel"
//                 aria-hidden="true"
//               >
//                 <div className="modal-dialog">
//                   <div className="modal-content">
//                     <div className="modal-header d-block">
//                       <div className="pop_cross">
//                         <IconButton aria-label="delete" data-bs-dismiss="modal">
//                           <CancelIcon className=" gray_text_up" />
//                         </IconButton>
//                       </div>

//                       <i
//                         className="fa fa-unlock color_Green_UP me-2 pop_Ic_up mt-3"
//                         aria-hidden="true"
//                       ></i>

//                       <h5
//                         className="modal-title text-center color_Green_UP pop_heading mb-3"
//                         id="staticBackdropLabel"
//                       >
//                         Unblock User?
//                       </h5>
//                       {/* <button
//                         type="button"
//                         className="btn-close"
//                         data-bs-dismiss="modal"
//                         aria-label="Close"
//                       ></button> */}
//                     </div>
//                     <div className="modal-body">
//                       <div className="row">
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Username:
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectUnblockDetails?.username}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                         <div className="col-md-6 mt_2">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Email-Id :
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectUnblockDetails?.email}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                       </div>
//                       <div className="row mt-2">
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Phone-Number:
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectUnblockDetails?.mobile}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Rolename:
//                           </label>
//                           <input
//                             disabled
//                             required
//                             className="form-control"
//                             placeholder="Sender Id Here"
//                             type="text"
//                             minLength="3"
//                             value={selectUnblockDetails?.roleName}
//                           />
//                         </div>
//                       </div>
//                       <div>
//                         <div className="row">
//                           <label className="fw-bold mt-3">
//                             Unblock Reason :
//                           </label>
//                           <div className="col-md-6">
//                             <input
//                               required
//                               className="form-control"
//                               placeholder="Unblock Reason Here"
//                               type="text"
//                               value={selectUnblockDetails.rejectedReason}
//                               onChange={(e) => {
//                                 setSelectUnblockDetails({
//                                   ...selectUnblockDetails,
//                                   rejectedReason: e.target.value,
//                                 });
//                               }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="modal-footer justify-content-center">
//                       {/* <button
//                         // ref={modelButtonRejectClose}
//                         ref={modelCloseUnlock}
//                         type="button"
//                         className="btn btn-secondary m-0"
//                         data-bs-dismiss="modal"
//                       >
//                         Close
//                       </button> */}
//                       <button
//                         type="submit"
//                         className="btn green_UP m-0"
//                         // data-bs-dismiss="modal"
//                       >
//                         Unblock User
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </>
//       )}

//       {selectUserDetailsBlock != undefined && (
//         <div>
//           <button
//             ref={modelEditUser}
//             type="button"
//             className="btn btn-primary d-none"
//             data-bs-toggle="modal"
//             data-bs-target="#staticBackdrop1"
//           >
//             Launch static backdrop modal
//           </button>

//           <div
//             className="modal fade"
//             id="staticBackdrop1"
//             data-bs-backdrop="static"
//             data-bs-keyboard="false"
//             tabindex="-1"
//             aria-labelledby="staticBackdrop1Label"
//             aria-hidden="true"
//           >
//             <div className="modal-dialog">
//               <div className="modal-content">
//                 <div className="modal-header d-block">
//                   <div className="pop_cross">
//                     <IconButton aria-label="delete" data-bs-dismiss="modal">
//                       <CancelIcon className=" gray_text_up" />
//                     </IconButton>
//                   </div>
//                   <BlockIcon className="pop_Ic_up color_red_UP" />

//                   <h5
//                     className="modal-title text-center color_red_UP mb-3 pop_heading"
//                     id="staticBackdrop1Label"
//                   >
//                     Block User?
//                   </h5>
//                 </div>

//                 <div className="modal-body">
//                   <div className="row">
//                     <div className="col-md-6">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Username:
//                       </label>
//                       <input
//                         disabled
//                         type="text"
//                         value={selectUserDetailsBlock?.username}
//                         className="form-control"
//                         id="exampleInputEmail1"
//                         aria-describedby="emailHelp"
//                       />
//                     </div>
//                     <div className="col-md-6 mt_2">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Email-Id :
//                       </label>
//                       <input
//                         disabled
//                         type="text"
//                         value={selectUserDetailsBlock?.email}
//                         className="form-control"
//                         id="exampleInputEmail1"
//                         aria-describedby="emailHelp"
//                       />
//                     </div>
//                   </div>
//                   <div className="row mt-2">
//                     <div className="col-md-6">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Phone-Number:
//                       </label>
//                       <input
//                         disabled
//                         type="text"
//                         value={selectUserDetailsBlock?.mobile}
//                         className="form-control"
//                         id="exampleInputEmail1"
//                         aria-describedby="emailHelp"
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Rolename:
//                       </label>
//                       <input
//                         disabled
//                         required
//                         className="form-control"
//                         placeholder="Sender Id Here"
//                         type="text"
//                         minLength="3"
//                         value={selectUserDetailsBlock?.roleName}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="modal-footer justify-content-center">
//                   {/* <button
//                     type="button"
//                     className="btn btn-secondary"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button> */}
//                   <button
//                     type="button"
//                     className="btn failClr text-center"
//                     data-bs-dismiss="modal"
//                     // data-bs-dismiss="modal"
//                     onClick={() => {
//                       blockUserAPI();
//                     }}
//                   >
//                     Block User
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* {selectedUserDetailApprove != undefined && selectVerifyDocuments != undefined && ( */}
//       <>
//         <div>
//           <button
//             ref={modelButtonApprove}
//             type="button"
//             className="btn btn-primary d-none"
//             data-bs-toggle="modal"
//             data-bs-target="#staticBackdrop7"
//           >
//             Launch static backdrop modal
//           </button>

//           <div
//             className="modal fade"
//             id="staticBackdrop7"
//             data-bs-backdrop="static"
//             data-bs-keyboard="false"
//             tabindex="-1"
//             aria-labelledby="staticBackdropLabel"
//             aria-hidden="true"
//           >
//             <div className="modal-dialog modal-xl">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title" id="staticBackdropLabel">
//                     User Approval?
//                   </h5>
//                   <button
//                     type="button"
//                     className="btn-close"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                   ></button>
//                 </div>
//                 <div className="modal-body">
//                   <div className="tab-content mt-3" id="myTabContent">
//                     <div
//                       className="tab-pane fade show active"
//                       id="home"
//                       role="tabpanel"
//                       aria-labelledby="home-tab"
//                     >
//                       <div className="row">
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Username:
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectedUserDetailApprove?.username}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                         <div className="col-md-6 mt_2">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Email-Id :
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectedUserDetailApprove?.email}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                       </div>
//                       <div className="row mt-2">
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Phone-Number:
//                           </label>
//                           <input
//                             disabled
//                             type="text"
//                             value={selectedUserDetailApprove?.mobile}
//                             className="form-control"
//                             id="exampleInputEmail1"
//                             aria-describedby="emailHelp"
//                           />
//                         </div>
//                         <div className="col-md-6">
//                           <label
//                             for="exampleInputEmail1"
//                             className="form-label"
//                           >
//                             Rolename:
//                           </label>
//                           <input
//                             disabled
//                             required
//                             className="form-control"
//                             placeholder="Sender Id Here"
//                             type="text"
//                             minLength="3"
//                             value={selectedUserDetailApprove?.roleName}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div
//                       className="tab-pane fade"
//                       id="profile"
//                       role="tabpanel"
//                       aria-labelledby="profile-tab"
//                     >
//                       {selectVerifyDocuments?.documentList?.length > 0 ? (
//                         <div>
//                           <label
//                             className="text-center d-block"
//                             style={{ fontSize: "21px" }}
//                           >
//                             Documents Uploaded by the User
//                           </label>

//                           {/* <div className="modal-body"> */}
//                           <table
//                             id="example"
//                             className="table table-striped table-bordered dataTable table-sm mt-3 "
//                           >
//                             <thead>
//                               <th>Document Image</th>
//                               <th>Document Name</th>
//                               <th>Status</th>
//                               <th>Action</th>
//                             </thead>
//                             {/* <tbody>

//                               <tr>
//                                 <td>
//                                   <img
//                                     src="http://192.168.167.66:5001/documents/248/download.jpg"
//                                     alt="Error in Loading Image"
//                                     className="img-fluid d-block"
//                                   />
//                                 </td>
//                                 <td>pan card</td>
//                                 <td>
//                                   <span className="badge bg-danger">Rejected</span>
//                                 </td>
//                                 </tr>

//                                </tbody> */}

//                             {selectVerifyDocuments?.documentList?.map(
//                               (d, index) => {
//                                 {
//                                   /* console.log(d.doumentUrl, "diocument image"); */
//                                 }
//                                 return (
//                                   <>
//                                     <tbody key={index}>
//                                       <tr>
//                                         <td>
//                                           <h1
//                                             aria-owns={
//                                               open1
//                                                 ? "mouse-over-popover"
//                                                 : undefined
//                                             }
//                                             aria-haspopup="true"
//                                             onMouseEnter={handlePopoverOpen}
//                                             onMouseLeave={handlePopoverClose}
//                                           >
//                                             <img
//                                               src={d?.doumentUrl}
//                                               alt="Error in Loading Image"
//                                               className="img-fluid d-block"
//                                             />
//                                           </h1>
//                                           <Popover
//                                             id="mouse-over-popover"
//                                             sx={{
//                                               pointerEvents: "none",
//                                               zIndex: 100000,
//                                             }}
//                                             open={open1}
//                                             anchorEl={anchorEl}
//                                             anchorOrigin={{
//                                               vertical: "bottom",
//                                               horizontal: "left",
//                                             }}
//                                             transformOrigin={{
//                                               vertical: "top",
//                                               horizontal: "left",
//                                             }}
//                                             onClose={handlePopoverClose}
//                                             disableRestoreFocus
//                                           >
//                                             <img
//                                               src={d?.doumentUrl}
//                                               alt="Error in Loading Image"
//                                               className="img-fluid d-block"
//                                             />
//                                           </Popover>

//                                           {/* <img
//                                             src={d?.doumentUrl}
//                                             alt="Error in Loading Image"
//                                             className="img-fluid d-block"
//                                           /> */}
//                                         </td>
//                                         <td>{d?.documentType}</td>
//                                         <td>
//                                           {" "}
//                                           {d?.approved == 0 ? (
//                                             <span className="badge bg-warning">
//                                               Pending
//                                             </span>
//                                           ) : d?.approved == 1 ? (
//                                             <span className="badge bg-success">
//                                               Approved
//                                             </span>
//                                           ) : (
//                                             <span className="badge bg-danger">
//                                               Rejected
//                                             </span>
//                                           )}
//                                         </td>
//                                         <td>
//                                           {openTextfield[d?.documentType] && (
//                                             <form onSubmit={rejectDocument}>
//                                               <input
//                                                 required
//                                                 className="w-100 form-control p-2 col-md-2"
//                                                 placeholder="Please Type Your Reject Reason Here"
//                                                 type="string"
//                                                 min="4"
//                                                 max="6"
//                                                 value={
//                                                   selectVerifyDocuments.rejectReason
//                                                 }
//                                                 onChange={(e) => {
//                                                   setSelectVerifyDocuments({
//                                                     ...selectVerifyDocuments,
//                                                     rejectReason:
//                                                       e.target.value,
//                                                   });
//                                                 }}
//                                               />
//                                               <div className="text-end">
//                                                 <button
//                                                   type="submit"
//                                                   className="btn btn-primary m-0 ms-2 mt-2"
//                                                   onClick={() => {
//                                                     selectVerifyDocuments.documentId =
//                                                       d;
//                                                   }}
//                                                 >
//                                                   Reject
//                                                 </button>
//                                                 <button
//                                                   style={{ marginTop: "20px" }}
//                                                   type="button"
//                                                   className="btn btn-primary m-0 ms-2 mt-2"
//                                                   onClick={() => {
//                                                     setOpenTextField({
//                                                       ...openTextfield,
//                                                       [d?.documentType]: false,
//                                                     });
//                                                   }}
//                                                 >
//                                                   Cancel
//                                                 </button>
//                                               </div>
//                                             </form>
//                                           )}

//                                           {!openTextfield[d?.documentType] && (
//                                             <>
//                                               <div className="">
//                                                 <div className="dropdown">
//                                                   <button
//                                                     className="btn color_1 dropdown-toggle"
//                                                     type="button"
//                                                     id="dropdownMenuButton1"
//                                                     data-bs-toggle="dropdown"
//                                                     aria-expanded="false"
//                                                   >
//                                                     <i className="material-icons opacity-10 size">
//                                                       person
//                                                     </i>
//                                                   </button>
//                                                   <ul
//                                                     className="dropdown-menu"
//                                                     aria-labelledby="dropdownMenuButton1"
//                                                   >
//                                                     <li>
//                                                       <a
//                                                         className="dropdown-item"
//                                                         onClick={(e) => {
//                                                           approveDocument(d);
//                                                         }}
//                                                       >
//                                                         Approve
//                                                       </a>
//                                                     </li>
//                                                     <li>
//                                                       <a
//                                                         className="dropdown-item"
//                                                         onClick={() => {
//                                                           setOpenTextField({
//                                                             ...openTextfield,
//                                                             [d?.documentType]: true,
//                                                           });
//                                                         }}
//                                                       >
//                                                         Reject
//                                                       </a>
//                                                     </li>
//                                                   </ul>
//                                                 </div>
//                                               </div>
//                                             </>
//                                           )}
//                                         </td>
//                                       </tr>
//                                     </tbody>
//                                     {/* <hr />
//                                   <td> */}
//                                     {/* <Popover
//                                       id="mouse-over-popover"
//                                       sx={{
//                                         pointerEvents: "none",
//                                         zIndex: 100000,
//                                       }}
//                                       open={open1}
//                                       anchorEl={anchorEl}
//                                       anchorOrigin={{
//                                         vertical: "bottom",
//                                         horizontal: "left",
//                                       }}
//                                       transformOrigin={{
//                                         vertical: "top",
//                                         horizontal: "left",
//                                       }}
//                                       onClose={handlePopoverClose}
//                                       disableRestoreFocus
//                                     >
//                                       <img
//                                         src={d?.doumentUrl}
//                                         alt="Error in Loading Image"
//                                         className="img-fluid d-block"
//                                       />
//                                     </Popover> */}
//                                     {/* <img
//                                       src={d?.doumentUrl}
//                                       alt="Error in Loading Image"
//                                       className="img-fluid d-block"
//                                     />

//                                    </td> */}
//                                     {/* <div className="col-md-2 text-center">
//                                     {d?.documentType}
//                                   </div>
//                                   <div className="col-md-3 text-center">
//                                     <div className="d-inline-block">
//                                       {d?.approved == 0 ? (
//                                         <span className="badge bg-warning">
//                                           Pending
//                                         </span>
//                                       ) : d?.approved == 1 ? (
//                                         <span className="badge bg-success">
//                                           Approved
//                                         </span>
//                                       ) : (
//                                         <span className="badge bg-danger">
//                                           Rejected
//                                         </span>
//                                       )}
//                                     </div>
//                                   </div> */}
//                                     {/* {hidebutton && ( */}
//                                     {/* <div className="col-md-5 text-center">
//                                     {openTextfield[d?.documentType] && (
//                                       <form onSubmit={rejectDocument}>
//                                         <input
//                                           required
//                                           className="w-100 form-control p-2 col-md-2"
//                                           placeholder="Please Type Your Reject Reason Here"
//                                           type="string"
//                                           min="4"
//                                           max="6"
//                                           value={
//                                             selectVerifyDocuments.rejectReason
//                                           }
//                                           onChange={(e) => {
//                                             setSelectVerifyDocuments({
//                                               ...selectVerifyDocuments,
//                                               rejectReason: e.target.value,
//                                             });
//                                           }}
//                                         />
//                                         <div className="text-end">
//                                           <button
//                                             type="submit"
//                                             className="btn btn-primary m-0 ms-2 mt-2"
//                                             onClick={() => {
//                                               selectVerifyDocuments.documentId =
//                                                 d;
//                                             }}
//                                           >
//                                             Reject
//                                           </button>
//                                           <button
//                                             style={{ marginTop: "20px" }}
//                                             type="button"
//                                             className="btn btn-primary m-0 ms-2 mt-2"
//                                             onClick={() => {
//                                               setOpenTextField({
//                                                 ...openTextfield,
//                                                 [d?.documentType]: false,
//                                               });
//                                             }}
//                                           >
//                                             Cancel
//                                           </button>
//                                         </div>
//                                       </form>
//                                     )}

//                                     {!openTextfield[d?.documentType] && (
//                                       <>
//                                         <div className="">
//                                           <div className="dropdown">
//                                             <button
//                                               className="btn color_1 dropdown-toggle"
//                                               type="button"
//                                               id="dropdownMenuButton1"
//                                               data-bs-toggle="dropdown"
//                                               aria-expanded="false"
//                                             >
//                                               <i className="material-icons opacity-10 size">
//                                                 person
//                                               </i>
//                                             </button>
//                                             <ul
//                                               className="dropdown-menu"
//                                               aria-labelledby="dropdownMenuButton1"
//                                             >
//                                               <li>
//                                                 <a
//                                                   className="dropdown-item"
//                                                   onClick={(e) => {
//                                                     approveDocument(d);
//                                                   }}
//                                                 >
//                                                   Approve
//                                                 </a>
//                                               </li>
//                                               <li>
//                                                 <a
//                                                   className="dropdown-item"
//                                                   onClick={() => {
//                                                     setOpenTextField({
//                                                       ...openTextfield,
//                                                       [d?.documentType]: true,
//                                                     });
//                                                   }}
//                                                 >
//                                                   Reject
//                                                 </a>
//                                               </li>
//                                             </ul>
//                                           </div>
//                                         </div>
//                                       </>
//                                     )}
//                                   </div> */}
//                                     {/* } */}
//                                   </>
//                                 );
//                               }
//                             )}
//                           </table>
//                         </div>
//                       ) : (
//                         <>
//                           <h5 className="m-0 text-center">
//                             No Documents Uploaded
//                           </h5>
//                         </>
//                       )}
//                     </div>
//                   </div>

//                   {/* <div className="modal-footer">
//                     <button
//                       // ref={modelButtonRejectClose}
//                       type="button"
//                       className="btn btn-secondary"
//                       data-bs-dismiss="modal"
//                     >
//                       Close
//                     </button>
//                     <button
//                       type="submit"
//                       className="btn btn-primary"
//                       data-bs-dismiss="modal"
//                       onClick={() => {
//                         approveUserApi();
//                       }}
//                     >
//                       Approve User
//                     </button>
//                   </div> */}
//                 </div>
//                 <div className="modal-footer">
//                   <button
//                     // ref={modelButtonRejectClose}
//                     type="button"
//                     className="btn btn-secondary"
//                     data-bs-dismiss="modal"
//                   >
//                     Close
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     data-bs-dismiss="modal"
//                     onClick={() => {
//                       approveUserApi();
//                     }}
//                   >
//                     Approve User
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>

//       {selectUserDetailsBlock != undefined && (
//         <>
//           <button
//             type="button"
//             ref={modelblockedUser}
//             className="btn btn-primary d-none"
//             data-bs-toggle="modal"
//             data-bs-target="#exmplModal3"
//           >
//             Launch demo modal
//           </button>

//           <form>
//             <div
//               className="modal fade"
//               id="exmplModal3"
//               tabindex="-1"
//               aria-labelledby="exampleModalLabel"
//               aria-hidden="true"
//             >
//               <div className="modal-dialog modal-lg">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <h5
//                       className="modal-title text-capitalize"
//                       id="exampleModalLabel3"
//                     >
//                       Are You Sure You Want To Block This User??
//                     </h5>
//                     <button
//                       type="button"
//                       className="btn-close m-0 p-0"
//                       data-bs-dismiss="modal"
//                       aria-label="Close"
//                     ></button>
//                   </div>
//                   <div className="modal-body">
//                     <div className="row">
//                       <div className="col-md-6 mt_2">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Username:
//                         </label>
//                         <input
//                           type="text"
//                           disabled
//                           value={selectedUserDetailApprove?.username}
//                           className="form-control"
//                           id="exampleInputEmail1"
//                           aria-describedby="emailHelp"
//                         />
//                       </div>
//                     </div>
//                     <div className="row mt-2">
//                       <div className="col-md-6">
//                         <label for="exampleInputEmail1" className="form-label">
//                           Rolename:
//                         </label>
//                         <input
//                           required
//                           disabled
//                           className="form-control"
//                           placeholder="Sender Id Here"
//                           type="text"
//                           minLength="3"
//                           value={selectedUserDetailApprove?.roleName}
//                           onChange={(e) => {
//                             setSelectedUserDetail({
//                               ...selectedUserDetail,
//                               senderId: e.target.value,
//                             });
//                           }}
//                         />
//                       </div>
//                     </div>
//                     <div className="col-md-6 mt_2">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Email-Id :
//                       </label>
//                       <input
//                         type="text"
//                         disabled
//                         value={selectedUserDetailApprove?.email}
//                         className="form-control"
//                         id="exampleInputEmail1"
//                         aria-describedby="emailHelp"
//                       />
//                     </div>
//                     <div className="col-md-6 mt_2">
//                       <label for="exampleInputEmail1" className="form-label">
//                         Phone-Number:
//                       </label>
//                       <input
//                         type="text"
//                         disabled
//                         value={selectedUserDetailApprove?.mobile}
//                         className="form-control"
//                         id="exampleInputEmail1"
//                         aria-describedby="emailHelp"
//                       />
//                     </div>
//                   </div>
//                   <div className="modal-footer">
//                     <button
//                       type="button"
//                       className="btn btn-secondary"
//                       data-bs-dismiss="modal"
//                     >
//                       Cancel
//                     </button>
//                     <div className="dropdown">
//                       <button
//                         className="btn color_1 dropdown-toggle"
//                         type="button"
//                         id="dropdownMenuButton1"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         <i className="material-icons opacity-10 size">person</i>
//                       </button>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="dropdownMenuButton1"
//                       >
//                         <li>
//                           <a
//                             className="dropdown-item"
//                             data-bs-dismiss="modal"
//                             onClick={() => {
//                               blockUserAPI();
//                             }}
//                           >
//                             Block User
//                           </a>
//                         </li>
//                         <li>
//                           <a
//                             className="dropdown-item"
//                             data-bs-dismiss="modal"
//                             onClick={() => {
//                               "Edit";
//                             }}
//                           >
//                             Deactivate User
//                           </a>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </>
//       )}

//       <div className="container-fluid">
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//         >
//           <Loader />
//         </Backdrop>
//         <ToastContainer autoClose={6000} />
//         <div className="card mb-3 mt-4">
//           <div className="card-header p-3 pt-2">
//             <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//               <SupervisedUserCircleIcon
//                 sx={{ color: "white", fontSize: "33px" }}
//               />
//               {/* <div>User Management</div> */}
//             </div>
//             <div
//               className="d-flex justify-content-between pt-1"
//               style={{ marginLeft: "76px" }}
//             >
//               <div className="fw-bold">View Users</div>
//             </div>
//           </div>

//           <div className="card-body">
//             <ul className="nav nav-tabs mt-2 " id="myTab" role="tablist">
//               <li className="nav-item ms-4" role="presentation">
//                 <button
//                   className="nav-link active position-relative"
//                   id="SenderMasking-tabb"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       tab: 5,
//                       pageNo: 0,
//                       pageSize: 10,
//                     });

//                     showSearch();
//                     setSearchIcon(false);
//                     setSearchBar(false);
//                     setRefreshButtonState(false);
//                     setApiNotHit(false);
//                   }}
//                 >
//                   <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill pending_Up ">
//                     {count?.allCount ? count?.allCount : "0"}
//                     <span className="visually-hidden">unread messages</span>
//                   </span>
//                   All Users
//                 </button>
//               </li>
//               <li className="nav-item ms-4" role="presentation">
//                 <button
//                   className="nav-link position-relative"
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       tab: 1,
//                       pageNo: 0,
//                       pageSize: 10,
//                     });
//                     showSearch();
//                     setSearchIcon(false);
//                     setSearchBar(false);
//                     setRefreshButtonState(false);
//                     setApiNotHit(false);
//                   }}
//                 >
//                   <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill approved_Up">
//                     {count?.apporved ? count?.apporved : "0"}
//                     <span className="visually-hidden">unread messages</span>
//                   </span>
//                   Approved
//                 </button>
//               </li>

//               <li className="nav-item ms-4" role="presentation">
//                 <button
//                   className="nav-link position-relative"
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     setStatus({
//                       ...Status,
//                       tab: 3,
//                       pageNo: 0,
//                       pageSize: 10,
//                     });
//                     showSearch();
//                     setSearchIcon(false);
//                     setSearchBar(false);
//                     setRefreshButtonState(false);
//                     setApiNotHit(false);
//                   }}
//                 >
//                   <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill failClr">
//                     {count?.blocked ? count?.blocked : "0"}
//                     <span className="visually-hidden">unread messages</span>
//                   </span>
//                   Blocked Users
//                 </button>
//               </li>
//             </ul>

//             {/* <div className="text-end" style={{ flexGrow: "1" }}>
//               <IconButton
//                 variant="text"
//                 size="small"
//                 sx={{
//                   color: "#7B809A",
//                 }}
//                 onClick={(event) => {
//                   setSearchIcon(!searchIcon);
//                 }}
//               >
//                 {searchIcon ? <CancelIcon /> : <SearchIcon />}
//               </IconButton>
//             </div> */}
//             {data?.length > 0 ? (
//               <>
//                 <div
//                   className="d-flex justify-content-between mt-3"
//                   style={{ minHeight: "4rem", maxHeight: "4rem" }}
//                 >
//                   {/* {searchIcon == true && ( */}
//                   <div className="my-auto">
//                     <div className="d-flex">
//                       <div className="my-auto">
//                         <select
//                           value={Status.pageSize}
//                           className="dropdown p-2"
//                           onChange={(e) => {
//                             setPageSize(Number(e.target.value));
//                             setStatus({
//                               ...Status,
//                               pageSize: e.target.value,
//                             });
//                           }}
//                         >
//                           {[10, 25, 50].map((value, i) => {
//                             return (
//                               <option
//                                 className="dropdown-menu"
//                                 aria-labelledby="dropdownMenuButton1"
//                                 value={value}
//                                 key={value}
//                               >
//                                 Show {value}
//                               </option>
//                             );
//                           })}
//                         </select>
//                       </div>
//                       <div className="my-auto ms-3">
//                         <div className="text-end" style={{ flexGrow: "1" }}>
//                           <IconButton
//                             variant="text"
//                             size="small"
//                             sx={{
//                               color: "#7B809A",
//                             }}
//                             onClick={(event) => {
//                               setSearchIcon(!searchIcon);
//                               setStatus({
//                                 ...Status,
//                                 searchType: null,
//                                 role: null,
//                                 msisdn: "",
//                                 userName: "",
//                                 status: null,
//                               });
//                               setRefreshButtonState(false);
//                               setApiNotHit(true);
//                             }}
//                           >
//                             {searchIcon ? <CancelIcon onClick={()=>{
                                 
//                                     fetchUser()
//                             }} /> : <SearchIcon />}
//                           </IconButton>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="my-auto">
//                     {searchIcon == true ? (
//                       <ThemeProvider theme={theme}>
//                         <div className="d-flex">
//                           <div className="col-md-4">
//                             <FormControl required fullWidth size="small">
//                               <InputLabel id="demo-simple-select-autowidth-label">
//                                 Select Search Category
//                               </InputLabel>
//                               <Select
//                                 labelId="demo-simple-select-autowidth-label"
//                                 id="demo-simple-select-autowidth"
//                                 value={Status.searchType}
//                                 onChange={(e) => {
//                                   setStatus({
//                                     ...Status,
//                                     searchType: e.target.value,
//                                     role: null,
//                                     msisdn: "",
//                                     userName: "",
//                                     status: null,
//                                   });
//                                 }}
//                                 autowidth
//                                 label="Select Search Category"
//                               >
//                                 {[
//                                   {
//                                     id: 1,
//                                     name: "Username",
//                                     value: "Username",
//                                   },
//                                   {
//                                     id: 2,
//                                     name: "Mobile Number",
//                                     value: "Mobile Number",
//                                   },

//                                   {/* {
//                                     id: 3,
//                                     name: "Role",
//                                     value: "Role",
//                                   },
//                                   searchStatus == false && {
//                                     id: 4,
//                                     name: "Active Status",
//                                     value: "Active Status",
//                                   }, */}
//                                 ].map((d) => {
//                                   return (
//                                     <MenuItem value={d.value}>
//                                       {" "}
//                                       {d.name}
//                                     </MenuItem>
//                                   );
//                                 })}
//                               </Select>
//                             </FormControl>
//                           </div>
//                           {Status.searchType == "Role" ? (
//                             <div className="col-md-4 ms-3">
//                               <FormControl required fullWidth size="small">
//                                 <InputLabel id="demo-simple-select-autowidth-label">
//                                   Role Type
//                                 </InputLabel>
//                                 <Select
//                                   labelId="demo-simple-select-autowidth-label"
//                                   id="demo-simple-select-autowidth"
//                                   value={Status.role}
//                                   onChange={(e) => {
//                                     setStatus({
//                                       ...Status,
//                                       role: e.target.value,
//                                     });
//                                   }}
//                                   autowidth
//                                   label="Role Type"
//                                 >
//                                   {[
//                                     { id: 1, name: "User", value: "User" },

//                                     {
//                                       id: 3,
//                                       name: "Admin",
//                                       value: "Admin",
//                                     },
//                                   ].map((d) => {
//                                     return (
//                                       <MenuItem value={d.value}>
//                                         {" "}
//                                         {d.name}
//                                       </MenuItem>
//                                     );
//                                   })}
//                                 </Select>
//                               </FormControl>
//                             </div>
//                           ) : null}
//                           {Status.searchType == "Username" ? (
//                             <div className="col-md-4 ms-3">
//                               <TextField
//                                 required
//                                 className="w-100"
//                                 label="Username"
//                                 name="userName"
//                                 variant="outlined"
//                                 size="small"
//                                 type="text"
//                                 value={Status.userName}
//                                 onChange={(e) => {
//                                   setStatus({
//                                     ...Status,
//                                     userName: e.target.value,
//                                   });
//                                 }}
//                               />
//                             </div>
//                           ) : null}
//                           {Status.searchType == "Mobile Number" ? (
//                             <div className="col-md-4 ms-3">
//                               <TextField
//                                 required
//                                 className="w-100"
//                                 label="Mobile Number"
//                                 name="msisdn"
//                                 variant="outlined"
//                                 size="small"
//                                 type="number"
//                                 value={Status.msisdn}
//                                 onChange={(e) => {
//                                   setStatus({
//                                     ...Status,
//                                     msisdn: e.target.value,
//                                   });
//                                 }}
//                               />
//                             </div>
//                           ) : null}

//                           {Status.searchType == "Active Status" ? (
//                             <div className="col-md-4 ms-3">
//                               {searchStatus == false ? (
//                                 <FormControl required fullWidth size="small">
//                                   <InputLabel id="demo-simple-select-autowidth-label">
//                                     Active Status
//                                   </InputLabel>
//                                   <Select
//                                     labelId="demo-simple-select-autowidth-label"
//                                     id="demo-simple-select-autowidth"
//                                     value={Status.status}
//                                     onChange={(e) => {
//                                       setStatus({
//                                         ...Status,
//                                         status: e.target.value,
//                                       });
//                                     }}
//                                     autowidth
//                                     label=" Active Status"
//                                   >
//                                     {[
//                                       {
//                                         id: 2,
//                                         name: "Approved",
//                                         value: "1",
//                                       },

//                                       {
//                                         id: 4,
//                                         name: "Blocked",
//                                         value: "3",
//                                       },
//                                     ].map((d) => {
//                                       return (
//                                         <MenuItem value={d.value}>
//                                           {" "}
//                                           {d.name}
//                                         </MenuItem>
//                                       );
//                                     })}
//                                   </Select>
//                                 </FormControl>
//                               ) : (
//                                 <></>
//                               )}
//                             </div>
//                           ) : null}

//                           <div className="col-md-6 ms-3 ">
//                             <div className="d-flex">
//                               <div className="">
//                                 <button
//                                   type="submit"
//                                   disabled={
//                                     Status.role == null &&
//                                     Status.status == null &&
//                                     Status.userName == "" &&
//                                     Status.msisdn == ""
//                                   }
//                                   className={
//                                     Status.role == null &&
//                                     Status.status == null &&
//                                     Status.userName == "" &&
//                                     Status.msisdn == ""
//                                       ? "btn bg-gradient-secondary mb-0"
//                                       : "btn btn-primary mb-0"
//                                   }
//                                   onClick={findUser}
//                                 >
//                                   <FilterAltIcon />
//                                 </button>
//                               </div>
//                               <div className="">
//                                 <button
//                                   type="submit"
//                                   className="btn resetBtn_UP ms-4 mb-0"
//                                   onClick={(e) => {
//                                     setStatus({
//                                       ...Status,

//                                       role: null,
//                                       msisdn: "",
//                                       userName: "",
//                                       status: null,
//                                     });
//                                     fetchUser();
//                                   }}
//                                 >
//                                   Reset
//                                   {/* <SearchIcon /> */}
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                           {/* <div className="col-md-2">
//                     <div className="text-end" style={{ flexGrow: "1" }}>
//                       <IconButton
//                         variant="text"
//                         size="small"
//                         sx={{
//                           color: "#7B809A",
//                         }}
//                         onClick={(event) => {
//                           setSearchIcon(!searchIcon);
//                         }}
//                       >
//                         {searchIcon ? <CancelIcon /> : <SearchIcon />}
//                       </IconButton>
//                     </div>
//                   </div> */}
//                         </div>
//                       </ThemeProvider>
//                     ) : (
//                       <div className="col-md-2 me-0 ms-auto"></div>
//                     )}
//                   </div>
//                   <div className="my-auto"></div>
//                   {/* )} */}
//                 </div>

//                 <div className="table_overFlow">
//                   <table
//                     {...getTableProps()}
//                     id="example"
//                     className="table table-striped table-bordered dataTable table-sm mt-3 "
//                     // className=" table table-responsive table-striped table-bordered dataTable mt-3"
//                   >
//                     <thead>
//                       {headerGroups.map((headerGroup) => (
//                         <tr {...headerGroup.getHeaderGroupProps()}>
//                           {headerGroup.headers.map((column) => (
//                             <th
//                               {...column.getHeaderProps(
//                                 column.getSortByToggleProps()
//                               )}
//                               className="text-center width_2"
//                             >
//                               {column.render("Header")}
//                               <span>
//                                 {column.isSorted
//                                   ? column.isSortedDesc
//                                     ? "↑"
//                                     : "↓"
//                                   : ""}
//                               </span>

//                               {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
//                             </th>
//                           ))}
//                         </tr>
//                       ))}
//                     </thead>
//                     <tbody
//                       className="mnu_item"
//                       id="dropdown-item"
//                       {...getTableBodyProps()}
//                     >
//                       {/* {rows.map((row) => {
//               prepareRow(row);
//               return (
//                 <tr {...row.getRowProps()}>
//                   {row.cells.map((cell) => {
//                     return (
//                       <td {...cell.getCellProps()} className="text-center">
//                         {cell.render("Cell")}
//                       </td>
//                     );
//                   })}
//                 </tr>
//               );
//             })} */}

//                       {page.map((row) => {
//                         prepareRow(row);
//                         return (
//                           <tr {...row.getRowProps()}>
//                             {row.cells.map((cell) => {
//                               return (
//                                 <td
//                                   {...cell.getCellProps()}
//                                   // className="text-left"
//                                   // className={
//                                   //         (cell.column.Header == "Id" ||
//                                   //           cell.column.Header ==
//                                   //             "Mobile Number" ||
//                                   //           cell.column.Header == "Id") &&
//                                   //         "text-end"
//                                   //       }
//                                   className={
//                                     cell.column.Header == "Mobile Number" ||
//                                     cell.column.Header == "Id"
//                                       ? "text-end"
//                                       : cell.column.Header == "Action" ||
//                                         cell.column.Header == "status"
//                                       ? "text-center"
//                                       : "text-start"
//                                   }
//                                 >
//                                   {cell.render("Cell")}
//                                 </td>
//                               );
//                             })}
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                     {/* <tfoot>
//             {footerGroups.map((footerGroup) => (
//               <tr {...footerGroup.getFooterGroupProps()}>
//                 {footerGroup.headers.map((column) => (
//                   <td className="text-center" {...column.getFooterProps}>
//                     {column.render("Footer")}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tfoot> */}
//                   </table>
//                 </div>

//                 <div className="d-flex justify-content-between mt-3">
//                   <div>
//                     <span>
//                       Page:
//                       <strong>
//                         {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
//                       </strong>
//                     </span>
//                   </div>

//                   <div>
//                     <button
//                       className="btn btn_primary "
//                       type="button"
//                       style={{ background: "#2C97D4" }}
//                       disabled={data1?.pageable?.pageNumber == 0}
//                       onClick={() => {
//                         setStatus({
//                           ...Status,
//                           pageNo: Status.pageNo - 1,
//                         });
//                       }}
//                     >
//                       Prev
//                     </button>

//                     <button
//                       className="btn btn_primary ms-2"
//                       type="button"
//                       style={{ background: "#2C97D4" }}
//                       disabled={
//                         data1?.totalPages == data1?.pageable?.pageNumber + 1
//                       }
//                       onClick={() => {
//                         setStatus({
//                           ...Status,
//                           pageNo: Status.pageNo + 1,
//                         });
//                       }}
//                     >
//                       Next
//                     </button>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="row">
//                   {refreshButtonState == true && (
//                     <>
//                       <div className="my-auto">
//                         <div className=" d-flex"></div>
//                       </div>

//                       <div
//                         className=""
//                         style={{ minHeight: "4rem", maxHeight: "4rem" }}
//                       >
//                         <div className="d-flex flex-wrap justify-content-between my-3">
//                           <div className="my-auto mx-4">
//                             <>
//                               <div className="" style={{ flexGrow: "1" }}>
//                                 <IconButton
//                                   variant="text"
//                                   size="small"
//                                   sx={{
//                                     color: "#7B809A",
//                                   }}
//                                   onClick={(event) => {
//                                     setSearchIcon(!searchIcon);
//                                     setStatus({
//                                       ...Status,
//                                       searchType: null,
//                                       role: null,
//                                       msisdn: "",
//                                       userName: "",
//                                       status: null,
//                                     });
//                                   }}
//                                 >
//                                   {searchIcon ? <CancelIcon onClick={()=>{
                                
//                                        setStatus({
//                                       ...Status,
                                   
//                                       role: null,
                                     
//                                     });
//                                     fetchUser()
//                                   }}/> : <SearchIcon />}
//                                 </IconButton>
//                               </div>
//                             </>
//                           </div>
//                           <div className="d-flex align-items-center">
//                             {searchIcon == true ? (
//                               <>
//                                 <div
//                                   className="d-flex me-3"
//                                   style={{ width: "200px" }}
//                                 >
//                                   <FormControl fullWidth>
//                                     <InputLabel
//                                       size="small"
//                                       id="test-select-label"
//                                     >
//                                       Select Search Category
//                                     </InputLabel>
//                                     <Select
//                                       labelId="demo-simple-select-autowidth-label"
//                                       id="demo-simple-select-autowidth"
//                                       value={Status.searchType}
//                                       onChange={(e) => {
//                                         setStatus({
//                                           ...Status,
//                                           searchType: e.target.value,
//                                           role: null,
//                                           msisdn: "",
//                                           userName: "",
//                                           status: null,
//                                         });
//                                       }}
//                                       autowidth
//                                       label="Select Search Category"
//                                     >
//                                       {[
//                                         {
//                                           id: 1,
//                                           name: "Username",
//                                           value: "Username",
//                                         },
//                                         {
//                                           id: 2,
//                                           name: "Mobile Number",
//                                           value: "Mobile Number",
//                                         },

//                                         {
//                                           id: 3,
//                                           name: "Role",
//                                           value: "Role",
//                                         },
//                                         searchStatus == false && {
//                                           id: 4,
//                                           name: "Active Status",
//                                           value: "Active Status",
//                                         },
//                                       ].map((d) => {
//                                         return (
//                                           <MenuItem value={d.value}>
//                                             {" "}
//                                             {d.name}
//                                           </MenuItem>
//                                         );
//                                       })}
//                                     </Select>
//                                   </FormControl>
//                                 </div>

//                                 <div className="d-flex">
//                                   {Status.searchType == "Role" ? (
//                                     <FormControl
//                                       required
//                                       fullWidth
//                                       size="small"
//                                     >
//                                       <InputLabel id="demo-simple-select-autowidth-label">
//                                         Role Type
//                                       </InputLabel>
//                                       <Select
//                                         labelId="demo-simple-select-autowidth-label"
//                                         id="demo-simple-select-autowidth"
//                                         value={Status.role}
//                                         onChange={(e) => {
//                                           setStatus({
//                                             ...Status,
//                                             role: e.target.value,
//                                           });
//                                         }}
//                                         autowidth
//                                         label="Role Type"
//                                       >
//                                         {[
//                                           {
//                                             id: 1,
//                                             name: "User",
//                                             value: "User",
//                                           },

//                                           {
//                                             id: 3,
//                                             name: "Admin",
//                                             value: "Admin",
//                                           },
//                                         ].map((d) => {
//                                           return (
//                                             <MenuItem value={d.value}>
//                                               {" "}
//                                               {d.name}
//                                             </MenuItem>
//                                           );
//                                         })}
//                                       </Select>
//                                     </FormControl>
//                                   ) : null}

//                                   {Status.searchType == "Username" ? (
//                                     <div
//                                       className="d-flex justify-content-between mx-3"
//                                       style={{ width: "200px" }}
//                                     >
//                                       <TextField
//                                         required
//                                         className="w-100"
//                                         label="Username"
//                                         name="userName"
//                                         variant="outlined"
//                                         size="small"
//                                         type="text"
//                                         value={Status.userName}
//                                         onChange={(e) => {
//                                           setStatus({
//                                             ...Status,
//                                             userName: e.target.value,
//                                           });
//                                         }}
//                                       />
//                                     </div>
//                                   ) : null}

//                                   {Status.searchType == "Mobile Number" ? (
//                                     <div
//                                       className="d-flex justify-content-between mx-3"
//                                       style={{ width: "200px" }}
//                                     >
//                                       <TextField
//                                         required
//                                         className="w-100"
//                                         label="Mobile Number"
//                                         name="msisdn"
//                                         variant="outlined"
//                                         size="small"
//                                         type="number"
//                                         value={Status.msisdn}
//                                         onChange={(e) => {
//                                           setStatus({
//                                             ...Status,
//                                             msisdn: e.target.value,
//                                           });
//                                         }}
//                                       />
//                                     </div>
//                                   ) : null}
//                                   {Status.searchType == "Active Status" ? (
//                                     <div className="col-md-4 ms-3">
//                                       {searchStatus == false ? (
//                                         <FormControl
//                                           required
//                                           fullWidth
//                                           size="small"
//                                         >
//                                           <InputLabel id="demo-simple-select-autowidth-label">
//                                             Active Status
//                                           </InputLabel>
//                                           <Select
//                                             labelId="demo-simple-select-autowidth-label"
//                                             id="demo-simple-select-autowidth"
//                                             value={Status.status}
//                                             onChange={(e) => {
//                                               setStatus({
//                                                 ...Status,
//                                                 status: e.target.value,
//                                               });
//                                             }}
//                                             autowidth
//                                             label=" Active Status"
//                                           >
//                                             {[
//                                               {
//                                                 id: 2,
//                                                 name: "Approved",
//                                                 value: "1",
//                                               },

//                                               {
//                                                 id: 4,
//                                                 name: "Blocked",
//                                                 value: "3",
//                                               },
//                                             ].map((d) => {
//                                               return (
//                                                 <MenuItem value={d.value}>
//                                                   {" "}
//                                                   {d.name}
//                                                 </MenuItem>
//                                               );
//                                             })}
//                                           </Select>
//                                         </FormControl>
//                                       ) : (
//                                         <></>
//                                       )}
//                                     </div>
//                                   ) : null}
//                                   <div className="d-flex justify-content-between">
//                                     <button
//                                       type="submit"
//                                       disabled={
//                                         Status.role == null &&
//                                         Status.status == null &&
//                                         Status.userName == "" &&
//                                         Status.msisdn == ""
//                                       }
//                                       className={
//                                         Status.role == null &&
//                                         Status.status == null &&
//                                         Status.userName == "" &&
//                                         Status.msisdn == ""
//                                           ? "btn bg-gradient-secondary mb-0"
//                                           : "btn btn-primary mb-0"
//                                       }
//                                       onClick={findUser}
//                                     >
//                                       <FilterAltIcon />
//                                     </button>
//                                   </div>
//                                   <div className="d-flex justify-content-between ms-3">
//                                     <button
//                                       onClick={() => {
//                                         setStatus({
//                                           ...Status,
//                                           selectorType: null,
//                                           resellerName: "",
//                                           type: null,
//                                           startTime: null,
//                                         });
//                                       }}
//                                       className="btn resetBtn_UP mb-0"
//                                     >
//                                       Reset
//                                     </button>
//                                   </div>
//                                 </div>
//                               </>
//                             ) : (
//                               <>
//                                 <div className="col-md-2 me-0 ms-auto"></div>
//                               </>
//                             )}
//                           </div>
//                           <Tooltip title="Refresh">
//                             <button
//                               type="submit"
//                               className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
//                                onClick={() => RefreshBtn("Text to Copy")}
//                             >
//                               <RefreshIcon />
//                             </button>
//                           </Tooltip>
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {data?.length == 0 && open ? null : (
//                     <div className="text-center">
//                       <h5>No Record Found..!!</h5>
//                     </div>
//                   )}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//       {/* <pre>
//         <code>
//           {JSON.stringify(
//             {
//               selectFlatRows: selectedFlatRows.map((row) => row.original),
//             },
//             null,
//             2
//           )}
//         </code>
//       </pre> */}
//     </main>
//   );
// }
























import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import * as React from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
// import { common_axios } from "../../../..";
import { common_axios } from "../../../../../App";
import { toast, ToastContainer } from "react-toastify";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ColumnFilter from "../../UserManagement/UserNewModule.jsx/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import {
  Autocomplete,
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  TextField,
  ThemeProvider,
  Typography,
  Tooltip,
  Stack,

} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Loader from "../../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { createTheme } from "@mui/material/styles";
import BlockIcon from "@mui/icons-material/Block";
import Zoom from "react-medium-image-zoom";
import { Link } from "react-router-dom";
import { Option } from "antd/lib/mentions";
import { useFormik } from "formik";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import Swal from "sweetalert2";
import SettingsIcon from "@mui/icons-material/Settings";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import Pagination from "@mui/material/Pagination";

export default function UserTableApproved() {
  const [open, setOpen] = useState(false);
  const [count, setcount] = useState(0);
  const [roleTypes, setRoleTypes] = useState("");
  const [openTextfield, setOpenTextField] = useState({});

  const [searchStatus, setSearchStatus] = useState(true);

  const [badgestatus, setbadgestatus] = useState(false);
  const [searchIcon, setSearchIcon] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [paginationPage, setPaginationPage] = React.useState(1);

  const [searchBar, setSearchBar] = useState(false);
  const customId1 = "custom-id-yess";
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectUserDetailsUpdate, setSelectUserDetailsUpdate] =
    useState(undefined);
  const [selectVerifyDocuments, setSelectVerifyDocuments] = useState(undefined);
  const [selectUnblockDetails, setSelectUnblockDetails] = useState(undefined);
  const [selectUserDetailsBlock, setSelectUserDetailsBlock] =
    useState(undefined);
  const [Status, setStatus] = useState({
    tab: 5,
    role: null,
    userName: "",
    msisdn: "",
    status: null,
    icon: false,
    pageNo: 0,
    pageSize: 10,
    searchType: null,
  });
  const [refreshButtonState, setRefreshButtonState] = useState(false);
  const [apiNotHit, setApiNotHit] = useState(false);

  const [rejectedReasonValues, setRejectedReasonValues] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(null);

  const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open1 = Boolean(anchorEl);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const showSearch = () => {
    if (Status.tab == 1 || Status.tab == 3) {
      setSearchStatus(true);
    } else {
      setSearchStatus(false);
    }
  };

  // const emptyRole = () => {
  //   if (Status == 1 || Status == 3 || Status == 4) {
  //     setTimeout(() => {
  //       search.role = null && (search.msisdn = "") && (search.userName = "");
  //     }, 1000);
  //   }
  // };
  useEffect(async () => {
    await showSearch();
    // await emptyRole();
  }, [Status.tab]);

  const fetchUser = async () => {
    setOpen(true);
    setData([]);
    try {
      const res = await common_axios.post("/admin/v1/admin/fetch/user-status", {
        userStatus: Status?.tab,
        pageNo: Status?.pageNo,
        pageSize: Status?.pageSize,
      });

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        if (res.data?.userModel) {
          setData(res.data?.userModel?.content);
          setData1(res.data?.userModel);
          setRefreshButtonState(false);
          setApiNotHit(false)
        }
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setOpen(false);
      } else {
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }

    // const res = await common_axios(
    //   `admin/v1/reseller/fetch/user-status/?userStatus=approved`
    // );
  };
  useEffect(async () => {
    fetchUser();
    getCountApi();
  }, [Status.tab, Status.pageNo, Status.pageSize]);


  const RefreshBtn = async () => {
    setOpen(true);
    setData([]);
    try {
      const res = await common_axios.post("/admin/v1/admin/fetch/user-status", {
        userStatus: Status?.tab,
        pageNo: Status?.pageNo,
        pageSize: Status?.pageSize,
      });

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        if (res.data?.userModel) {
          setData(res.data?.userModel?.content);
          setData1(res.data?.userModel);
          // setRefreshButtonState(false);
          // setApiNotHit(false)
        }
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setOpen(false);
      } else {
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }

    // const res = await common_axios(
    //   `admin/v1/reseller/fetch/user-status/?userStatus=approved`
    // );
  };
  const findUser = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(`admin/v1/user/find`, {
        role: Status.role,
        userName: Status.userName != "" ? Status.userName : null,
        msisdn: Status.msisdn != "" ? Status.msisdn : null,
        activeStatus: Status.status == null ? Status.status : [Status.status],
        pageNo: Status?.pageNo,
        pageSize: Status?.pageSize,
        userStatus: Status?.tab,
      });

      if (res.data.statusDescription.statusCode == 200) {
        setData(res.data?.userModel?.content);
        setData1(res.data?.userModel);
        // setStatus({
        //   ...Status,
        //   userName: "",
        // });
        setOpen(false);
        setApiNotHit(true);

        setRefreshButtonState(false);
      } else if (res.data?.statusDescription?.statusCode == 201) {
        setData([]);
        setOpen(false);
        setApiNotHit(true);
        // setStatus({
        //   ...Status,
        //   resellerName: "",
        // });
        setRefreshButtonState(true);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No Record Found",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error("No data Found", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No data Found",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const getCountApi = async () => {
    const res = await common_axios(
      `${process.env.REACT_APP_COMMON_API}/admin/v1/${
        roleType.name == "ROLE_RESELLER" ? "reseller" : "admin"
      }/user/status/count/`
    );

    if (res.data.statusDescription.statusCode == 200) {
      let obj = {
        allCount: 0,
      };

      for (let index = 0; index < res?.data?.userStatusList?.length; index++) {
        const element = res?.data?.userStatusList?.[index];

        if (element.status == 1) {
          obj["apporved"] = element.count;
          obj["allCount"] += element.count;
        }
        if (element.status == 3) {
          obj["blocked"] = element.count;
          obj["allCount"] += element.count;
        }
      }
      setcount(obj);
    }
  };

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonRejectClose = useRef();
  const modelButtonApprove = useRef(null);
  const modelVerifyDocuments = useRef(null);
  const modelEditUser = useRef(null);
  const modelblockedUser = useRef(null);
  const verifyDetails = useRef(null);
  const unblockUser = useRef(null);
  const modelCloseUnlock = useRef(null);

  const modelUpdateUser = useRef(null);
  const updateUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectUserDetailsUpdate(cell.row.original);
    // await setSelectedUserDetailApprove(cell.row.original);
    await modelCloseUnlock.current?.click();
  };

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current?.click();
    let objectt = {};
    await cell.row.original.documentList.forEach((element) => {
      // console.log(element);
      objectt[element.documentType] = false;
    });

    setOpenTextField(objectt);
    await setSelectVerifyDocuments(cell.row.original);
    // await modelVerifyDocuments.current.click();
  };
  const editApprovedModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectUserDetailsBlock(cell.row.original);
    // await setSelectedUserDetailApprove(cell.row.original);
    await modelEditUser.current?.click();
  };
  const blockedUserModal = async (cell) => {
    // console.log(cell.row.original);
    await modelblockedUser.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setRejectedReasonValues(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const unblockUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectUnblockDetails(cell?.row?.original);
    await unblockUser?.current?.click();
  };
  const verifyDocumentsModal = async (cell) => {
    let objectt = {};
    await cell.row.original.documentList.forEach((element) => {
      // console.log(element);
      objectt[element.documentType] = false;
    });

    setOpenTextField(objectt);
    await setSelectVerifyDocuments(cell.row.original);
    await modelVerifyDocuments.current.click();
  };

  const rejectUserApi = async (e) => {
    e.preventDefault();
    try {
      modelButtonRejectClose.current?.click();
      setOpen(true);
      const res = await common_axios.post(`/admin/v1/user/reject/`, {
        cpId: selectedUserDetail.uid,
        rejectReason:
          selectedUserDetail.rejectedReason == "Other"
            ? selectedUserDetail.rejectedReasonText
            : selectedUserDetail.rejectedReason,
      });

      if (res.data.statusDescription.statusCode == 200) {
        await modelButtonRejectClose.current?.click();
        setOpen(false);
        setSelectedUserDetail();
        fetchUser();
        // await toast.success("User has been rejected", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "User has been rejected",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        await setOpen(false);
        await fetchUser();
        await setSelectedUserDetail();
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      modelButtonRejectClose.current?.click();
      await setSelectedUserDetail();
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  const unblockUserAPi = async (e, cell) => {
    e.preventDefault();
    try {
      setOpen(true);
      const res = await common_axios.post(
        `/admin/v1/unblock/user/?cpId=${selectUnblockDetails?.uid}`,
        {
          cpId: selectUnblockDetails?.uid,
          unBlockReason: selectUnblockDetails.rejectedReason,
          // unBlockReason: "is a valid user",
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        modelCloseUnlock?.current?.click();
        setSelectUnblockDetails();
        fetchUser();
        setOpen(false);
        // await setStatus("approved");
        // await toast.success("User unblocked", {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "User unblocked",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      modelCloseUnlock?.current?.click();
      setSelectUnblockDetails();
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const approveUserApi = async (cell) => {
    try {
      setOpen(true);
      const res = await common_axios(
        `/admin/v1/user/approve/?cpId=${selectedUserDetailApprove.uid}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        fetchUser();
        setOpen(false);
        // await setStatus("approved");
        // await toast.success("User has been approved", {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "User has been approved",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  const blockUserAPI = async (cell) => {
    try {
      setOpen(true);
      const res = await common_axios(
        `/admin/v1/block/user/?cpId=${selectUserDetailsBlock?.uid}`
      );

      if (res.data.statusDescription.statusCode == 200) {
        fetchUser();
        setOpen(false);
        // await setStatus("approved");
        // await toast.success("User has been Blocked", {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "User has been Blocked",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  // const rejectUser = async (cpId) => {
  //   const res = await common_axios.post(`/admin/v1/user/reject/`, {
  //     cpId,
  //     rejectReason: "not valid user",
  //   });
  //   await setStatus("rejected");

  //   console.log(res.data);
  // };

  const approveUser = async (cpId) => {
    const res = await common_axios(`/admin/v1/user/approve/?cpId=${cpId}`);

    await setStatus("approved");

    // console.log(res.data);
  };

  const columns = useMemo(
    () => [
      // {
      //   Header: "S.No",
      //   Footer: "S.No",
      //   accessor: "serialnumber",
      //   Cell: (row, index) => {
      //     console.log(row, "helloo");
      //     return <>{row.row.index}</>;
      //   },
      // },
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => (
          //  <>{cell.row.index +1}</>
          <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
        ),
      },
      {
        Header: "User Name",
        Footer: "User Name",
        accessor: "username", // accessor is the "key" in the data
      },
      // {
      //   Header: "Role",
      //   Footer: "Role",
      //   accessor: "userRoleId",
      // },
      {
        Header: "Email-Id",
        Footer: "Email-Id",
        accessor: "email",
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            <div>
              {cell.row.original.email ? (
                <div>{cell.row.original.email}</div>
              ) : (
                <div>NA</div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Role",
        Footer: "Role",
        accessor: "roleName",
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            // <div>
            //   {cell.row.original.roleName == "user" ? (
            //     <div>User</div>
            //   ) : (
            //     <div>Reseller</div>
            //   )}
            // </div>
            <>
              {cell.row.original.roleName == "user" ? (
                <>
                  <div>User</div>
                </>
              ) : cell.row.original.roleName == "reseller" ? (
                <>
                  <div>Reseller</div>
                </>
              ) : cell.row.original.roleName == "admin" ? (
                <>
                  <div>Admin</div>
                </>
              ) : (
                <>N/A</>
              )}
            </>
          );
        },
      },
      {
        Header: " Account Status",
        Footer: " Account Status",
        accessor: "status",
        Cell: (cell) => {
          // console.log(
          //   cell,
          //   cell.row.original,
          //   cell.row.original.status,
          //   cell.cell.row.original.enabled
          // );
          // const function2 = () => {
          //   if (cell.row.original.enabled == "false") {
          //     <div className="badge rounded-pill bg-danger">Blocked</div>;
          //   }
          // };
          // console.log("going", cell.row.original.enabled == false);
          return (
            <>
              {cell.row.original.approved == 3 ? (
                <>
                  {" "}
                  <div className="badge badge_8 failClr fs_table_up">
                    Blocked
                  </div>
                </>
              ) : cell.row.original.approved == 0 ? (
                <>
                  {" "}
                  <div className="badge badge_8 pending_Up fs_table_up">
                    Pending{" "}
                  </div>
                </>
              ) : cell.row.original.approved == 1 ? (
                <>
                  <div className="badge badge_8 approved_Up fs_table_up">
                    Approved
                  </div>
                </>
              ) : cell.row.original.approved == 2 ? (
                <>
                  {" "}
                  <div className="badge badge_8 failClr fs_table_up">
                    Rejected
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "Mobile Verfication",
      //   Footer: " Mobile  Verfication",
      //   accessor: "otpVerification",
      //   Cell: (cell) => {
      //     console.log(cell.row.original, cell.row.original.status);
      //     return (
      //       // <div>
      //       //   {cell.row.original.roleName == "user" ? (
      //       //     <div>User</div>
      //       //   ) : (
      //       //     <div>Reseller</div>
      //       //   )}
      //       // </div>
      //       <>
      //         {cell.row.original.otpVerification == true &&
      //         cell.row.original.approved == 0 ? (
      //           <>
      //             <div className="badge badge_8 bg-success">Verified</div>
      //           </>
      //         ) : cell.row.original.otpVerification == false &&
      //           "null" &&
      //           cell.row.original.approved == 0 ? (
      //           <>
      //             <div className="badge badge_8 bg-warning">Not Verified</div>
      //           </>
      //         ) : cell.row.original.otpVerification == true &&
      //           "null" &&
      //           cell.row.original.approved == 1 ? (
      //           <>
      //             <div className="badge badge_8 bg-success">Verified</div>
      //           </>
      //         ) : cell.row.original.otpVerification == false ||
      //           ("null" && cell.row.original.approved == 2) ? (
      //           <>
      //             <div className="badge badge_8 bg-warning">Not Verified</div>
      //           </>
      //         ) : (
      //           cell.row.original.otpVerification == false ||
      //           ("null" && cell.row.original.approved == 3 && (
      //             <>
      //               <div className="badge badge_8 bg-warning">Not Verified</div>
      //             </>
      //           ))
      //         )}
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Mobile Number",

        accessor: "mobile",
      },
      // {
      //   Header: "Details",
      //   Footer: "Details",
      //   accessor: "details",
      //   Cell: (cell) => {
      //     return (
      //       <>
      //         <Link to={`/dashboard/UserDetail/${cell.row.original.uid}`}>
      //           <button className="btn btn-primary mb-0" type="button">
      //             Configuration
      //           </button>
      //         </Link>
      //       </>
      //     );
      //   },

      //   disableFilters: true,
      // },
      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          return (
            <div className="d-flex justify-content-center align-items-center">
              <div className="dropdown">
                <button
                  className="btn color_1 dropdown-toggle px-2"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="material-icons opacity-10 size">person</i>
                </button>
                {cell.row.original.enabled == false ? (
                  <>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            unblockUserModal(cell);
                          }}
                        >
                          <i
                            className="fa fa-unlock color_Green_UP me-2"
                            aria-hidden="true"
                          ></i>
                          Unblock User
                        </a>
                      </li>
                    </ul>
                  </>
                ) : cell.row.original.approved == 0 ? (
                  <>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        onClick={() => {
                          // console.log(cell, "hello");
                        }}
                      >
                        <a
                          className="dropdown-item "
                          onClick={() => {
                            rejectUserModal(cell);
                          }}
                        >
                          <i className="fa fa-ban me-2" aria-hidden="true"></i>
                          Reject User
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            approveUserModal(cell);
                          }}
                        >
                          <i
                            className="fa fa-thumbs-up me-2"
                            aria-hidden="true"
                          ></i>
                          Approve User
                        </a>
                      </li>
                      {/* <li>
                      <Link to={`/dashboard/EditUser/${cell.row.original.uid}`}>
                        <EditIcon />
                        Edit User
                      </Link>
                    </li> */}
                    </ul>
                  </>
                ) : cell.row.original.approved == 1 ? (
                  <>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {/* <li className="dropdown-item">
                      <Link
                        to={`/dashboard/UserDetail/${cell.row.original.uid}`}
                      >
                        View Details
                      </Link>
                    </li> */}

                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            editApprovedModal(cell);
                          }}
                        >
                          {/* <i className="fa fa-pencil me-2 color_Green_UP" aria-hidden="true"></i> */}
                          <BlockIcon className="color_red_UP me-2 my-auto" />
                          Block User
                        </a>
                      </li>
                    </ul>
                  </>
                ) : (
                  cell.row.original.approved == 2 && (
                    <>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        {/* <li className="dropdown-item">
                        <Link
                          to={`/dashboard/UserDetail/${cell.row.original.uid}`}
                        >
                          <i className="fa fa-info-circle" aria-hidden="true"></i>
                          View Details
                        </Link>
                      </li> */}
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              updateUserModal(cell);
                            }}
                          >
                            <ThumbUpAltIcon />
                            Update User
                          </a>
                        </li>
                      </ul>
                    </>
                  )
                )}
              </div>
              <ul>
                <li>
                  <a
                    className="dropdown-item px-2"
                    // onClick={() => {
                    //   approveUserModal(cell);
                    // }}
                  >
                    <Link to={`/dashboard/UserDetail/${cell.row.original.uid}`}>
                      <SettingsIcon />
                    </Link>
                    {/* View Details */}
                  </a>
                </li>
              </ul>
            </div>
          );
        },

        disableFilters: true,
      },
    ],
    [Status]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  const approveDocument = async (docu) => {
    try {
      setOpen(true);
      modelClose?.current?.click();
      const res = await common_axios.post(`admin/v1/document/verify`, {
        docId: docu.id,
        cpId: selectVerifyDocuments.uid,
        action: "approve",
      });

      if (res.data.statusDescription.statusCode == 200) {
        setbadgestatus(true);

        fetchUser();
        setOpen(false);
        modelClose?.current?.click();
        // await setStatus("pending");
        // await toast.success("Document Approved", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Document Approved",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  const rejectDocument = async (e, docu) => {
    e.preventDefault();

    try {
      setOpen(true);
      const res = await common_axios.post(`admin/v1/document/verify`, {
        docId: selectVerifyDocuments.documentId.id,
        cpId: selectVerifyDocuments.uid,
        action: "reject",
        rejectReason: selectVerifyDocuments.rejectReason,
      });

      if (res.data.statusDescription.statusCode == 200) {
        fetchUser();
        setOpen(false);
        modelClose?.current?.click();
        // await setStatus("pending");
        // await toast.success("Document Rejected", {
        //   theme: "colored",
        //   toastId: customId1,
        // });

        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Document Rejected",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const modelOpen = useRef();
  const modelClose1 = useRef();
  const modelClose = useRef();

  const textfiledRef = useRef(null);

  const textfieldClick = async () => {
    await textfiledRef.current.click();
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  // console.log({ selectVerifyDocuments });
  // console.log({ selectedUserDetail });

  useEffect(() => {
    if (Status?.userName === "" && apiNotHit === true) {
      // alert("enter")
      fetchUser();
    }
  }, [Status?.userName]);
  console.log("xyx--",refreshButtonState,apiNotHit,Status?.userName)
  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetail != undefined && (
        <div>
          <button
            ref={modelButtonReject}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>
          <form onSubmit={rejectUserApi}>
            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabIndex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                      User Rejection
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Username:
                        </label>
                        <input
                          disabled
                          type="text"
                          value={selectedUserDetail?.username}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Email-Id :
                        </label>
                        <input
                          disabled
                          type="text"
                          value={selectedUserDetail?.email}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Phone-Number:
                        </label>
                        <input
                          disabled
                          type="text"
                          value={selectedUserDetail?.mobile}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Rolename:
                        </label>
                        <input
                          disabled
                          required
                          className="form-control"
                          placeholder="Sender Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.roleName}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="fw-bold mt-3 w-100">
                          Rejected Reason :
                          <select
                            required
                            className="form-select mt-2"
                            name="reason"
                            id="reason"
                            onChange={(e) => {
                              if (e.target.value == "Other") {
                                selectedUserDetail.rejectedReasonText = "";
                              }
                              setSelectedUserDetail({
                                ...selectedUserDetail,
                                rejectedReason: e.target.value,
                              });
                            }}
                          >
                            <option value="Incorrect User Information">
                              Incorrect User Information
                            </option>
                            <option value="Incorrect Documents">
                              Incorrect Documents
                            </option>
                            <option value="Details-Documents Mismatch">
                              Details-Documents Mismatch
                            </option>
                            <option value="Other">Other</option>
                          </select>
                          {selectedUserDetail.rejectedReason == "Other" && (
                            <input
                              required
                              className="form-control mt-2"
                              placeholder="Rejected Reason Here"
                              type="text"
                              value={selectedUserDetail.rejectedReasonText}
                              onChange={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  rejectedReasonText: e.target.value,
                                });
                              }}
                            />
                          )}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      ref={modelButtonRejectClose}
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      // data-bs-dismiss="modal"
                    >
                      Reject User
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}

      {selectUnblockDetails != undefined && (
        <>
          <div>
            <button
              ref={unblockUser}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop9"
            >
              Launch static backdrop modal
            </button>
            <form onSubmit={unblockUserAPi}>
              <div
                className="modal fade"
                id="staticBackdrop9"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header d-block">
                      <div className="pop_cross">
                        <IconButton aria-label="delete" data-bs-dismiss="modal">
                          <CancelIcon className=" gray_text_up" />
                        </IconButton>
                      </div>

                      <i
                        className="fa fa-unlock color_Green_UP me-2 pop_Ic_up mt-3"
                        aria-hidden="true"
                      ></i>

                      <h5
                        className="modal-title text-center color_Green_UP pop_heading mb-3"
                        id="staticBackdropLabel"
                      >
                        Unblock User?
                      </h5>
                      {/* <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button> */}
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Username:
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectUnblockDetails?.username}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                        <div className="col-md-6 mt_2">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Email-Id :
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectUnblockDetails?.email}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Phone-Number:
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectUnblockDetails?.mobile}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Rolename:
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectUnblockDetails?.roleName}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="row">
                          <label className="fw-bold mt-3">
                            Unblock Reason :
                          </label>
                          <div className="col-md-6">
                            <input
                              required
                              className="form-control"
                              placeholder="Unblock Reason Here"
                              type="text"
                              value={selectUnblockDetails.rejectedReason}
                              onChange={(e) => {
                                setSelectUnblockDetails({
                                  ...selectUnblockDetails,
                                  rejectedReason: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-center">
                      {/* <button
                        // ref={modelButtonRejectClose}
                        ref={modelCloseUnlock}
                        type="button"
                        className="btn btn-secondary m-0"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button> */}
                      <button
                        type="submit"
                        className="btn green_UP m-0"
                        // data-bs-dismiss="modal"
                      >
                        Unblock User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </>
      )}

      {selectUserDetailsBlock != undefined && (
        <div>
          <button
            ref={modelEditUser}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header d-block">
                  <div className="pop_cross">
                    <IconButton aria-label="delete" data-bs-dismiss="modal">
                      <CancelIcon className=" gray_text_up" />
                    </IconButton>
                  </div>
                  <BlockIcon className="pop_Ic_up color_red_UP" />

                  <h5
                    className="modal-title text-center color_red_UP mb-3 pop_heading"
                    id="staticBackdrop1Label"
                  >
                    Block User?
                  </h5>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Username:
                      </label>
                      <input
                        disabled
                        type="text"
                        value={selectUserDetailsBlock?.username}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Email-Id :
                      </label>
                      <input
                        disabled
                        type="text"
                        value={selectUserDetailsBlock?.email}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Phone-Number:
                      </label>
                      <input
                        disabled
                        type="text"
                        value={selectUserDetailsBlock?.mobile}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Rolename:
                      </label>
                      <input
                        disabled
                        required
                        className="form-control"
                        placeholder="Sender Id Here"
                        type="text"
                        minLength="3"
                        value={selectUserDetailsBlock?.roleName}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-center">
                  {/* <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button> */}
                  <button
                    type="button"
                    className="btn failClr text-center"
                    data-bs-dismiss="modal"
                    // data-bs-dismiss="modal"
                    onClick={() => {
                      blockUserAPI();
                    }}
                  >
                    Block User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {selectedUserDetailApprove != undefined && selectVerifyDocuments != undefined && ( */}
      <>
        <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop7"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop7"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    User Approval?
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="tab-content mt-3" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Username:
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectedUserDetailApprove?.username}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                        <div className="col-md-6 mt_2">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Email-Id :
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectedUserDetailApprove?.email}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Phone-Number:
                          </label>
                          <input
                            disabled
                            type="text"
                            value={selectedUserDetailApprove?.mobile}
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Rolename:
                          </label>
                          <input
                            disabled
                            required
                            className="form-control"
                            placeholder="Sender Id Here"
                            type="text"
                            minLength="3"
                            value={selectedUserDetailApprove?.roleName}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      {selectVerifyDocuments?.documentList?.length > 0 ? (
                        <div>
                          <label
                            className="text-center d-block"
                            style={{ fontSize: "21px" }}
                          >
                            Documents Uploaded by the User
                          </label>

                          {/* <div className="modal-body"> */}
                          <table
                            id="example"
                            className="table table-striped table-bordered dataTable table-sm mt-3 "
                          >
                            <thead>
                              <th>Document Image</th>
                              <th>Document Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </thead>
                            {/* <tbody>

                              <tr>
                                <td>
                                  <img
                                    src="http://192.168.167.66:5001/documents/248/download.jpg"
                                    alt="Error in Loading Image"
                                    className="img-fluid d-block"
                                  />
                                </td>
                                <td>pan card</td>
                                <td>
                                  <span className="badge bg-danger">Rejected</span>
                                </td>
                                </tr>

                               </tbody> */}

                            {selectVerifyDocuments?.documentList?.map(
                              (d, index) => {
                                {
                                  /* console.log(d.doumentUrl, "diocument image"); */
                                }
                                return (
                                  <>
                                    <tbody key={index}>
                                      <tr>
                                        <td>
                                          <h1
                                            aria-owns={
                                              open1
                                                ? "mouse-over-popover"
                                                : undefined
                                            }
                                            aria-haspopup="true"
                                            onMouseEnter={handlePopoverOpen}
                                            onMouseLeave={handlePopoverClose}
                                          >
                                            <img
                                              src={d?.doumentUrl}
                                              alt="Error in Loading Image"
                                              className="img-fluid d-block"
                                            />
                                          </h1>
                                          <Popover
                                            id="mouse-over-popover"
                                            sx={{
                                              pointerEvents: "none",
                                              zIndex: 100000,
                                            }}
                                            open={open1}
                                            anchorEl={anchorEl}
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "left",
                                            }}
                                            transformOrigin={{
                                              vertical: "top",
                                              horizontal: "left",
                                            }}
                                            onClose={handlePopoverClose}
                                            disableRestoreFocus
                                          >
                                            <img
                                              src={d?.doumentUrl}
                                              alt="Error in Loading Image"
                                              className="img-fluid d-block"
                                            />
                                          </Popover>

                                          {/* <img
                                            src={d?.doumentUrl}
                                            alt="Error in Loading Image"
                                            className="img-fluid d-block"
                                          /> */}
                                        </td>
                                        <td>{d?.documentType}</td>
                                        <td>
                                          {" "}
                                          {d?.approved == 0 ? (
                                            <span className="badge bg-warning">
                                              Pending
                                            </span>
                                          ) : d?.approved == 1 ? (
                                            <span className="badge bg-success">
                                              Approved
                                            </span>
                                          ) : (
                                            <span className="badge bg-danger">
                                              Rejected
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          {openTextfield[d?.documentType] && (
                                            <form onSubmit={rejectDocument}>
                                              <input
                                                required
                                                className="w-100 form-control p-2 col-md-2"
                                                placeholder="Please Type Your Reject Reason Here"
                                                type="string"
                                                min="4"
                                                max="6"
                                                value={
                                                  selectVerifyDocuments.rejectReason
                                                }
                                                onChange={(e) => {
                                                  setSelectVerifyDocuments({
                                                    ...selectVerifyDocuments,
                                                    rejectReason:
                                                      e.target.value,
                                                  });
                                                }}
                                              />
                                              <div className="text-end">
                                                <button
                                                  type="submit"
                                                  className="btn btn-primary m-0 ms-2 mt-2"
                                                  onClick={() => {
                                                    selectVerifyDocuments.documentId =
                                                      d;
                                                  }}
                                                >
                                                  Reject
                                                </button>
                                                <button
                                                  style={{ marginTop: "20px" }}
                                                  type="button"
                                                  className="btn btn-primary m-0 ms-2 mt-2"
                                                  onClick={() => {
                                                    setOpenTextField({
                                                      ...openTextfield,
                                                      [d?.documentType]: false,
                                                    });
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            </form>
                                          )}

                                          {!openTextfield[d?.documentType] && (
                                            <>
                                              <div className="">
                                                <div className="dropdown">
                                                  <button
                                                    className="btn color_1 dropdown-toggle"
                                                    type="button"
                                                    id="dropdownMenuButton1"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                  >
                                                    <i className="material-icons opacity-10 size">
                                                      person
                                                    </i>
                                                  </button>
                                                  <ul
                                                    className="dropdown-menu"
                                                    aria-labelledby="dropdownMenuButton1"
                                                  >
                                                    <li>
                                                      <a
                                                        className="dropdown-item"
                                                        onClick={(e) => {
                                                          approveDocument(d);
                                                        }}
                                                      >
                                                        Approve
                                                      </a>
                                                    </li>
                                                    <li>
                                                      <a
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                          setOpenTextField({
                                                            ...openTextfield,
                                                            [d?.documentType]: true,
                                                          });
                                                        }}
                                                      >
                                                        Reject
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                    {/* <hr />
                                  <td> */}
                                    {/* <Popover
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                        zIndex: 100000,
                                      }}
                                      open={open1}
                                      anchorEl={anchorEl}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}
                                      transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                      }}
                                      onClose={handlePopoverClose}
                                      disableRestoreFocus
                                    >
                                      <img
                                        src={d?.doumentUrl}
                                        alt="Error in Loading Image"
                                        className="img-fluid d-block"
                                      />
                                    </Popover> */}
                                    {/* <img
                                      src={d?.doumentUrl}
                                      alt="Error in Loading Image"
                                      className="img-fluid d-block"
                                    />

                                   </td> */}
                                    {/* <div className="col-md-2 text-center">
                                    {d?.documentType}
                                  </div>
                                  <div className="col-md-3 text-center">
                                    <div className="d-inline-block">
                                      {d?.approved == 0 ? (
                                        <span className="badge bg-warning">
                                          Pending
                                        </span>
                                      ) : d?.approved == 1 ? (
                                        <span className="badge bg-success">
                                          Approved
                                        </span>
                                      ) : (
                                        <span className="badge bg-danger">
                                          Rejected
                                        </span>
                                      )}
                                    </div>
                                  </div> */}
                                    {/* {hidebutton && ( */}
                                    {/* <div className="col-md-5 text-center">
                                    {openTextfield[d?.documentType] && (
                                      <form onSubmit={rejectDocument}>
                                        <input
                                          required
                                          className="w-100 form-control p-2 col-md-2"
                                          placeholder="Please Type Your Reject Reason Here"
                                          type="string"
                                          min="4"
                                          max="6"
                                          value={
                                            selectVerifyDocuments.rejectReason
                                          }
                                          onChange={(e) => {
                                            setSelectVerifyDocuments({
                                              ...selectVerifyDocuments,
                                              rejectReason: e.target.value,
                                            });
                                          }}
                                        />
                                        <div className="text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-primary m-0 ms-2 mt-2"
                                            onClick={() => {
                                              selectVerifyDocuments.documentId =
                                                d;
                                            }}
                                          >
                                            Reject
                                          </button>
                                          <button
                                            style={{ marginTop: "20px" }}
                                            type="button"
                                            className="btn btn-primary m-0 ms-2 mt-2"
                                            onClick={() => {
                                              setOpenTextField({
                                                ...openTextfield,
                                                [d?.documentType]: false,
                                              });
                                            }}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </form>
                                    )}

                                    {!openTextfield[d?.documentType] && (
                                      <>
                                        <div className="">
                                          <div className="dropdown">
                                            <button
                                              className="btn color_1 dropdown-toggle"
                                              type="button"
                                              id="dropdownMenuButton1"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <i className="material-icons opacity-10 size">
                                                person
                                              </i>
                                            </button>
                                            <ul
                                              className="dropdown-menu"
                                              aria-labelledby="dropdownMenuButton1"
                                            >
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={(e) => {
                                                    approveDocument(d);
                                                  }}
                                                >
                                                  Approve
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() => {
                                                    setOpenTextField({
                                                      ...openTextfield,
                                                      [d?.documentType]: true,
                                                    });
                                                  }}
                                                >
                                                  Reject
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div> */}
                                    {/* } */}
                                  </>
                                );
                              }
                            )}
                          </table>
                        </div>
                      ) : (
                        <>
                          <h5 className="m-0 text-center">
                            No Documents Uploaded
                          </h5>
                        </>
                      )}
                    </div>
                  </div>

                  {/* <div className="modal-footer">
                    <button
                      // ref={modelButtonRejectClose}
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi();
                      }}
                    >
                      Approve User
                    </button>
                  </div> */}
                </div>
                <div className="modal-footer">
                  <button
                    // ref={modelButtonRejectClose}
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      approveUserApi();
                    }}
                  >
                    Approve User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      {selectUserDetailsBlock != undefined && (
        <>
          <button
            type="button"
            ref={modelblockedUser}
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#exmplModal3"
          >
            Launch demo modal
          </button>

          <form>
            <div
              className="modal fade"
              id="exmplModal3"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5
                      className="modal-title text-capitalize"
                      id="exampleModalLabel3"
                    >
                      Are You Sure You Want To Block This User??
                    </h5>
                    <button
                      type="button"
                      className="btn-close m-0 p-0"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Username:
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailApprove?.username}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Rolename:
                        </label>
                        <input
                          required
                          disabled
                          className="form-control"
                          placeholder="Sender Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailApprove?.roleName}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              senderId: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Email-Id :
                      </label>
                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.email}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Phone-Number:
                      </label>
                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.mobile}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <div className="dropdown">
                      <button
                        className="btn color_1 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons opacity-10 size">person</i>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            data-bs-dismiss="modal"
                            onClick={() => {
                              blockUserAPI();
                            }}
                          >
                            Block User
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            data-bs-dismiss="modal"
                            onClick={() => {
                              "Edit";
                            }}
                          >
                            Deactivate User
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        <ToastContainer autoClose={6000} />
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <SupervisedUserCircleIcon
                sx={{ color: "white", fontSize: "33px" }}
              />
              {/* <div>User Management</div> */}
            </div>
            <div
              className="d-flex justify-content-between pt-1"
              style={{ marginLeft: "76px" }}
            >
              <div className="fw-bold">View Users</div>
            </div>
          </div>

          <div className="card-body">
            <ul className="nav nav-tabs mt-2 " id="myTab" role="tablist">
              <li className="nav-item ms-4" role="presentation">
                <button
                  className="nav-link active position-relative"
                  id="SenderMasking-tabb"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      tab: 5,
                      pageNo: 0,
                      pageSize: 10,
                    });

                    showSearch();
                    setSearchIcon(false);
                    setSearchBar(false);
                    setRefreshButtonState(false);
                    setApiNotHit(false);
                    setPaginationPage(1)

                  }}
                >
                  <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill pending_Up ">
                    {count?.allCount ? count?.allCount : "0"}
                    <span className="visually-hidden">unread messages</span>
                  </span>
                  All Users
                </button>
              </li>
              <li className="nav-item ms-4" role="presentation">
                <button
                  className="nav-link position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      tab: 1,
                      pageNo: 0,
                      pageSize: 10,
                    });
                    showSearch();
                    setSearchIcon(false);
                    setSearchBar(false);
                    setRefreshButtonState(false);
                    setApiNotHit(false);
                    setPaginationPage(1)
                  }}
                >
                  <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill approved_Up">
                    {count?.apporved ? count?.apporved : "0"}
                    <span className="visually-hidden">unread messages</span>
                  </span>
                  Approved
                </button>
              </li>

              <li className="nav-item ms-4" role="presentation">
                <button
                  className="nav-link position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      tab: 3,
                      pageNo: 0,
                      pageSize: 10,
                    });
                    showSearch();
                    setSearchIcon(false);
                    setSearchBar(false);
                    setRefreshButtonState(false);
                    setApiNotHit(false);
                    setPaginationPage(1)

                  }}
                >
                  <span className="position-absolute spn_8 top-0 start-100 translate-middle badge rounded-pill failClr">
                    {count?.blocked ? count?.blocked : "0"}
                    <span className="visually-hidden">unread messages</span>
                  </span>
                  Blocked Users
                </button>
              </li>
            </ul>

            {/* <div className="text-end" style={{ flexGrow: "1" }}>
              <IconButton
                variant="text"
                size="small"
                sx={{
                  color: "#7B809A",
                }}
                onClick={(event) => {
                  setSearchIcon(!searchIcon);
                }}
              >
                {searchIcon ? <CancelIcon /> : <SearchIcon />}
              </IconButton>
            </div> */}
            {data?.length > 0 ? (
              <>
                <div
                  className="d-flex justify-content-between mt-3"
                  style={{ minHeight: "4rem", maxHeight: "4rem" }}
                >
                  {/* {searchIcon == true && ( */}
                  <div className="my-auto">
                    <div className="d-flex">
                      <div className="my-auto">
                        <select
                          value={Status.pageSize}
                          className="dropdown p-2"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setStatus({
                              ...Status,
                              pageSize: e.target.value,
                            });
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="my-auto ms-3">
                        <div className="text-end" style={{ flexGrow: "1" }}>
                          <IconButton
                            variant="text"
                            size="small"
                            sx={{
                              color: "#7B809A",
                            }}
                            onClick={(event) => {
                              setSearchIcon(!searchIcon);
                              setStatus({
                                ...Status,
                                searchType: null,
                                role: null,
                                msisdn: "",
                                userName: "",
                                status: null,
                              });
                              setRefreshButtonState(false);
                              setApiNotHit(true);
                            }}
                          >
                            {searchIcon ? <CancelIcon onClick={()=>{
                                 
                                    fetchUser()
                            }} /> : <SearchIcon />}
                          </IconButton>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="my-auto">
                    {searchIcon == true ? (
                      <ThemeProvider theme={theme}>
                        <div className="d-flex">
                          <div className="col-md-4">
                            <FormControl required fullWidth size="small">
                              <InputLabel id="demo-simple-select-autowidth-label">
                                Select Search Category
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={Status.searchType}
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,
                                    searchType: e.target.value,
                                    role: null,
                                    msisdn: "",
                                    userName: "",
                                    status: null,
                                  });
                                }}
                                autowidth
                                label="Select Search Category"
                              >
                                {[
                                  {
                                    id: 1,
                                    name: "Username",
                                    value: "Username",
                                  },
                                  {
                                    id: 2,
                                    name: "Mobile Number",
                                    value: "Mobile Number",
                                  },

                                  {/* {
                                    id: 3,
                                    name: "Role",
                                    value: "Role",
                                  },
                                  searchStatus == false && {
                                    id: 4,
                                    name: "Active Status",
                                    value: "Active Status",
                                  }, */}
                                ].map((d) => {
                                  return (
                                    <MenuItem value={d.value}>
                                      {" "}
                                      {d.name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>
                          {Status.searchType == "Role" ? (
                            <div className="col-md-4 ms-3">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Role Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={Status.role}
                                  onChange={(e) => {
                                    setStatus({
                                      ...Status,
                                      role: e.target.value,
                                    });
                                  }}
                                  autowidth
                                  label="Role Type"
                                >
                                  {[
                                    { id: 1, name: "User", value: "User" },

                                    {
                                      id: 3,
                                      name: "Admin",
                                      value: "Admin",
                                    },
                                  ].map((d) => {
                                    return (
                                      <MenuItem value={d.value}>
                                        {" "}
                                        {d.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}
                          {Status.searchType == "Username" ? (
                            <div className="col-md-4 ms-3">
                              <TextField
                                required
                                className="w-100"
                                label="Username"
                                name="userName"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={Status.userName}
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,
                                    userName: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          ) : null}
                          {Status.searchType == "Mobile Number" ? (
                            <div className="col-md-4 ms-3">
                              <TextField
                                required
                                className="w-100"
                                label="Mobile Number"
                                name="msisdn"
                                variant="outlined"
                                size="small"
                                type="number"
                                value={Status.msisdn}
                                onChange={(e) => {
                                  setStatus({
                                    ...Status,
                                    msisdn: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          ) : null}

                          {Status.searchType == "Active Status" ? (
                            <div className="col-md-4 ms-3">
                              {searchStatus == false ? (
                                <FormControl required fullWidth size="small">
                                  <InputLabel id="demo-simple-select-autowidth-label">
                                    Active Status
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={Status.status}
                                    onChange={(e) => {
                                      setStatus({
                                        ...Status,
                                        status: e.target.value,
                                      });
                                    }}
                                    autowidth
                                    label=" Active Status"
                                  >
                                    {[
                                      {
                                        id: 2,
                                        name: "Approved",
                                        value: "1",
                                      },

                                      {
                                        id: 4,
                                        name: "Blocked",
                                        value: "3",
                                      },
                                    ].map((d) => {
                                      return (
                                        <MenuItem value={d.value}>
                                          {" "}
                                          {d.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              ) : (
                                <></>
                              )}
                            </div>
                          ) : null}

                          <div className="col-md-6 ms-3 ">
                            <div className="d-flex">
                              <div className="">
                                <button
                                  type="submit"
                                  disabled={
                                    Status.role == null &&
                                    Status.status == null &&
                                    Status.userName == "" &&
                                    Status.msisdn == ""
                                  }
                                  className={
                                    Status.role == null &&
                                    Status.status == null &&
                                    Status.userName == "" &&
                                    Status.msisdn == ""
                                      ? "btn bg-gradient-secondary mb-0"
                                      : "btn btn-primary mb-0"
                                  }
                                  onClick={findUser}
                                >
                                  <FilterAltIcon />
                                </button>
                              </div>
                              <div className="">
                                <button
                                  type="submit"
                                  className="btn resetBtn_UP ms-4 mb-0"
                                  onClick={(e) => {
                                    setStatus({
                                      ...Status,

                                      role: null,
                                      msisdn: "",
                                      userName: "",
                                      status: null,
                                    });
                                    fetchUser();
                                  }}
                                >
                                  Reset
                                  {/* <SearchIcon /> */}
                                </button>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-2">
                    <div className="text-end" style={{ flexGrow: "1" }}>
                      <IconButton
                        variant="text"
                        size="small"
                        sx={{
                          color: "#7B809A",
                        }}
                        onClick={(event) => {
                          setSearchIcon(!searchIcon);
                        }}
                      >
                        {searchIcon ? <CancelIcon /> : <SearchIcon />}
                      </IconButton>
                    </div>
                  </div> */}
                        </div>
                      </ThemeProvider>
                    ) : (
                      <div className="col-md-2 me-0 ms-auto"></div>
                    )}
                  </div>
                  <div className="my-auto"></div>
                  {/* )} */}
                </div>

                <div className="table_overFlow">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3 "
                    // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>

                              {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody
                      className="mnu_item onhover_change"
                      id="dropdown-item"
                      {...getTableBodyProps()}
                    >
                      {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className="text-left"
                                  // className={
                                  //         (cell.column.Header == "Id" ||
                                  //           cell.column.Header ==
                                  //             "Mobile Number" ||
                                  //           cell.column.Header == "Id") &&
                                  //         "text-end"
                                  //       }
                                  className={
                                    cell.column.Header == "Mobile Number" ||
                                    cell.column.Header == "Id"
                                      ? "text-end"
                                      : cell.column.Header == "Action" ||
                                        cell.column.Header == "status"
                                      ? "text-center"
                                      : "text-start"
                                  }
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                    {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                  </table>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>


                  <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setStatus({
                          ...Status,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setStatus({
                    ...Status,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setStatus({
                          ...Status,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)

                      }}
                    >
                      Last
                    </button>
                
              </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  {refreshButtonState == true && (
                    <>
                      <div className="my-auto">
                        <div className=" d-flex"></div>
                      </div>

                      <div
                        className=""
                        style={{ minHeight: "4rem", maxHeight: "4rem" }}
                      >
                        <div className="d-flex flex-wrap justify-content-between my-3">
                          <div className="my-auto mx-4">
                            <>
                              <div className="" style={{ flexGrow: "1" }}>
                                <IconButton
                                  variant="text"
                                  size="small"
                                  sx={{
                                    color: "#7B809A",
                                  }}
                                  onClick={(event) => {
                                    setSearchIcon(!searchIcon);
                                    setStatus({
                                      ...Status,
                                      searchType: null,
                                      role: null,
                                      msisdn: "",
                                      userName: "",
                                      status: null,
                                    });
                                  }}
                                >
                                  {searchIcon ? <CancelIcon onClick={()=>{
                                
                                       setStatus({
                                      ...Status,
                                   
                                      role: null,
                                     
                                    });
                                    fetchUser()
                                  }}/> : <SearchIcon />}
                                </IconButton>
                              </div>
                            </>
                          </div>

                          
                          <div className="d-flex align-items-center">
                            {searchIcon == true ? (
                              <>
                                <div
                                  className="d-flex me-3"
                                  style={{ width: "200px" }}
                                >
                                  <FormControl fullWidth>
                                    <InputLabel
                                      size="small"
                                      id="test-select-label"
                                    >
                                      Select Search Category
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={Status.searchType}
                                      onChange={(e) => {
                                        setStatus({
                                          ...Status,
                                          searchType: e.target.value,
                                          role: null,
                                          msisdn: "",
                                          userName: "",
                                          status: null,
                                        });
                                      }}
                                      autowidth
                                      label="Select Search Category"
                                    >
                                      {[
                                        {
                                          id: 1,
                                          name: "Username",
                                          value: "Username",
                                        },
                                        {
                                          id: 2,
                                          name: "Mobile Number",
                                          value: "Mobile Number",
                                        },

                                        {
                                          id: 3,
                                          name: "Role",
                                          value: "Role",
                                        },
                                        searchStatus == false && {
                                          id: 4,
                                          name: "Active Status",
                                          value: "Active Status",
                                        },
                                      ].map((d) => {
                                        return (
                                          <MenuItem value={d.value}>
                                            {" "}
                                            {d.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>

                                <div className="d-flex">
                                  {Status.searchType == "Role" ? (
                                    <FormControl
                                      required
                                      fullWidth
                                      size="small"
                                    >
                                      <InputLabel id="demo-simple-select-autowidth-label">
                                        Role Type
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-autowidth-label"
                                        id="demo-simple-select-autowidth"
                                        value={Status.role}
                                        onChange={(e) => {
                                          setStatus({
                                            ...Status,
                                            role: e.target.value,
                                          });
                                        }}
                                        autowidth
                                        label="Role Type"
                                      >
                                        {[
                                          {
                                            id: 1,
                                            name: "User",
                                            value: "User",
                                          },

                                          {
                                            id: 3,
                                            name: "Admin",
                                            value: "Admin",
                                          },
                                        ].map((d) => {
                                          return (
                                            <MenuItem value={d.value}>
                                              {" "}
                                              {d.name}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                  ) : null}

                                  {Status.searchType == "Username" ? (
                                    <div
                                      className="d-flex justify-content-between mx-3"
                                      style={{ width: "200px" }}
                                    >
                                      <TextField
                                        required
                                        className="w-100"
                                        label="Username"
                                        name="userName"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        value={Status.userName}
                                        onChange={(e) => {
                                          setStatus({
                                            ...Status,
                                            userName: e.target.value,
                                          });
                                        }}
                                      />
                                    </div>
                                  ) : null}

                                  {Status.searchType == "Mobile Number" ? (
                                    <div
                                      className="d-flex justify-content-between mx-3"
                                      style={{ width: "200px" }}
                                    >
                                      <TextField
                                        required
                                        className="w-100"
                                        label="Mobile Number"
                                        name="msisdn"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        value={Status.msisdn}
                                        onChange={(e) => {
                                          setStatus({
                                            ...Status,
                                            msisdn: e.target.value,
                                          });
                                        }}
                                      />
                                    </div>
                                  ) : null}
                                  {Status.searchType == "Active Status" ? (
                                    <div className="col-md-4 ms-3">
                                      {searchStatus == false ? (
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Active Status
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={Status.status}
                                            onChange={(e) => {
                                              setStatus({
                                                ...Status,
                                                status: e.target.value,
                                              });
                                            }}
                                            autowidth
                                            label=" Active Status"
                                          >
                                            {[
                                              {
                                                id: 2,
                                                name: "Approved",
                                                value: "1",
                                              },

                                              {
                                                id: 4,
                                                name: "Blocked",
                                                value: "3",
                                              },
                                            ].map((d) => {
                                              return (
                                                <MenuItem value={d.value}>
                                                  {" "}
                                                  {d.name}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  ) : null}

                                  <div className="d-flex justify-content-between">
                                    <button
                                      type="submit"
                                      disabled={
                                        Status.role == null &&
                                        Status.status == null &&
                                        Status.userName == "" &&
                                        Status.msisdn == ""
                                      }
                                      className={
                                        Status.role == null &&
                                        Status.status == null &&
                                        Status.userName == "" &&
                                        Status.msisdn == ""
                                          ? "btn bg-gradient-secondary mb-0"
                                          : "btn btn-primary mb-0"
                                      }
                                      onClick={findUser}
                                    >
                                      <FilterAltIcon />
                                    </button>
                                  </div>
                                  <div className="d-flex justify-content-between ms-3">
                                    <button
                                      onClick={() => {
                                        setStatus({
                                          ...Status,
                                          selectorType: null,
                                          resellerName: "",
                                          type: null,
                                          startTime: null,
                                        });
                                      }}
                                      className="btn resetBtn_UP mb-0"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="col-md-2 me-0 ms-auto"></div>
                              </>
                            )}
                          </div>

                          
                          <Tooltip title="Refresh">
                            <button
                              type="submit"
                              className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                               onClick={() => RefreshBtn("Text to Copy")}
                            >
                              <RefreshIcon />
                            </button>
                          </Tooltip>
                        </div>
                      </div>
                    </>
                  )}

                  {data?.length == 0 && open ? null : (
                    <div className="text-center">
                      <h5>No Record Found..!!</h5>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <pre>
        <code>
          {JSON.stringify(
            {
              selectFlatRows: selectedFlatRows.map((row) => row.original),
            },
            null,
            2
          )}
        </code>
      </pre> */}
    </main>
  );
}
